import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import { usePermissions } from '../../utils/permissions';
import {
  Box, Container, Paper, Grid, Divider,
  Typography, TextField, Button, IconButton,
  Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, CircularProgress, Alert, Chip,
  Card, CardContent, CardMedia, CardActions,
  FormControl, InputLabel, Select, MenuItem, OutlinedInput, InputAdornment,
  Tabs, Tab, Autocomplete, Dialog, DialogTitle,
  DialogContent, DialogActions, Tooltip, Switch,
  FormControlLabel, Checkbox, Snackbar, Badge,
  Avatar, Link as MuiLink, useTheme, alpha, Fade,
  Stepper, Step, StepLabel, StepContent, StepConnector, stepConnectorClasses,
  TablePagination, styled
} from '@mui/material';
import { useParams, useNavigate, Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import ScienceIcon from '@mui/icons-material/Science';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import InventoryIcon from '@mui/icons-material/Inventory';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import QrCodeIcon from '@mui/icons-material/QrCode';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SaveIcon from '@mui/icons-material/Save';
import VerifiedIcon from '@mui/icons-material/Verified';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

//
// -- Modern Styled Components --
//
const SectionPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(3),
  position: 'relative',
  borderRadius: 16,
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.02)})`,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.15)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  animation: 'slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '@keyframes slideInUp': {
    '0%': {
      transform: 'translateY(100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1,
    }
  },
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.25)}`
  }
}));

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: theme.palette.primary.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <CheckIcon className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.2rem',
  color: theme.palette.primary.main,
  letterSpacing: '-0.3px',
  '& .MuiSvgIcon-root': {
    marginRight: theme.spacing(2),
    fontSize: 28,
    backgroundColor: 'black',
    color: 'white',
    borderRadius: 8,
    padding: theme.spacing(1),
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.25)}`
  }
}));

const ModernCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)}, ${alpha(theme.palette.primary.main, 0.01)})`,
  boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.12)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.15)}`,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
    '& .product-actions': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  },
  '& .product-actions': {
    opacity: 0,
    transform: 'translateY(10px)',
    transition: 'all 0.3s ease'
  }
}));

const StepContentBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha(theme.palette.grey[100], 0.8)}, ${alpha(theme.palette.grey[50], 0.9)})`,
  borderRadius: 12,
  padding: theme.spacing(4),
  margin: theme.spacing(2, 0),
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.08)}`
}));



const BrandNameHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(5),
  padding: theme.spacing(2, 3),
  borderRadius: 8,
  background: 'white',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderLeft: `4px solid ${theme.palette.primary.main}`
}));

const BrandNameTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  margin: 0
}));

const ProductTableContainer = styled(Paper)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(6),
  overflow: 'hidden',
  borderRadius: 8,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  background: `linear-gradient(135deg, ${alpha(theme.palette.grey[100], 0.8)}, ${alpha(theme.palette.grey[50], 0.9)})`,
  boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.15)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  animation: 'slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '@keyframes slideInUp': {
    '0%': {
      transform: 'translateY(100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1,
    }
  },
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.25)}`,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
  }
}));

const StepperContainer = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.02)})`,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  borderRadius: 16,
  padding: theme.spacing(4),
  marginBottom: theme.spacing(3)
}));

const StepperNavigationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2, 0),
  borderTop: `1px solid ${alpha(theme.palette.grey[300], 0.8)}`
}));

// TabPanel component for tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

// Add this near the top of the file with other utility functions
// Calculate profit margin consistently
const calculateProfitMargin = (retailPrice, costPrice) => {
  retailPrice = parseFloat(retailPrice) || 0;
  costPrice = parseFloat(costPrice) || 0;
  
  if (retailPrice <= 0) return '0';
  
  const margin = ((retailPrice - costPrice) / retailPrice) * 100;
  return margin.toFixed(2);
};

// Define the steps for the product creation stepper
const steps = [
  {
    label: 'Basic Information',
    description: 'Enter product details and specifications',
    icon: <InfoOutlinedIcon />
  },
  {
    label: 'Product Variants',
    description: 'Configure different sizes and pricing',
    icon: <InventoryIcon />
  },
  {
    label: 'Formulation Details',
    description: 'Add formulation and shelf life information',
    icon: <ScienceIcon />
  },
  {
    label: 'Ingredients & Certifications',
    description: 'Specify ingredients, skin type, and certifications',
    icon: <FormatListBulletedIcon />
  },
  {
    label: 'Application Instructions',
    description: 'Provide usage instructions for customers',
    icon: <MenuBookIcon />
  }
];

export default function ProductsPage() {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const { canAccessPage, canEditPage, hasPermission, isManagerOrAbove, userRole, hierarchyLevel } = usePermissions();
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [view, setView] = useState('grid');
  const [currentTab, setCurrentTab] = useState(0);
  const [viewTab, setViewTab] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [companyName, setCompanyName] = useState('');

  // Data states
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [editingProduct, setEditingProduct] = useState(null);
  const [viewingProduct, setViewingProduct] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [showViewDialog, setShowViewDialog] = useState(false);
  
  // Filter states
  const [filters, setFilters] = useState({
    search: '',
    skinType: 'all',
    inStock: false,
    priceRange: [0, 1000],
  });
  
  // Constants
  const skinTypes = ['All Skin Types', 'Normal', 'Dry', 'Oily', 'Combination', 'Sensitive', 'Acne-Prone', 'Mature'];
  const volumeUnits = ['ml', 'g', 'oz', 'fl oz', 'L', 'kg'];
  const certifications = ['Organic', 'Vegan', 'Cruelty-Free', 'Fair Trade', 'Natural', 'EWG Verified', 'Dermatologist Tested'];
  
  // Product - absolute bare minimum
  const createEmptyProduct = () => ({
    name: '',
    sku: '',
    barcode: '',
    description: '',
    default_price: '',  // Changed from retail_price

    cost_price: '',
    volume_weight: '',
    volume_unit: '',
    pack_quantity: 1,
    brand_id: '',
    category_id: '',
    ingredients: '',
    skin_type: '',
    skin_concerns: [],
    certifications: [],
    ph_level: '',
    benefits: '',
    active_ingredients: '',
    packaging_details: '',
    application_instructions: '',
    fragrance: false,
    allergens: '',
    shelf_life_months: '',
    product_code: '',
    product_type: 'In-House',
    status: 'Active',
    packaging_used: '',
    label_version: '',
    launch_date: '',
    has_variants: false,
    is_active: true
  });

  // Use the minimal function
  const [newProduct, setNewProduct] = useState(createEmptyProduct());
  const [variants, setVariants] = useState([]);
  const [originalVariants, setOriginalVariants] = useState([]); // Track original variants for deletion
  
  // Add these state variables to the top of your component with the other state definitions
  const [viewFormulation, setViewFormulation] = useState(null);
  const [formulationIngredients, setFormulationIngredients] = useState([]);
  
  // Add a Category Creation Dialog
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [brandDialogOpen, setBrandDialogOpen] = useState(false);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [brandSearchTerm, setBrandSearchTerm] = useState('');
  const [categorySearchTerm, setCategorySearchTerm] = useState('');
  const [newCategory, setNewCategory] = useState({
    name: '',
    description: '',
    parent_id: null,
  });
  
  // Filter dialogs for brand and category selection (different from product creation)
  const [brandFilterDialogOpen, setBrandFilterDialogOpen] = useState(false);
  const [categoryFilterDialogOpen, setCategoryFilterDialogOpen] = useState(false);
  const [brandFilterSearchTerm, setBrandFilterSearchTerm] = useState('');
  const [categoryFilterSearchTerm, setCategoryFilterSearchTerm] = useState('');
  
  // Pagination state for brand tables
  const [brandPagination, setBrandPagination] = useState({});
  
  // Get pagination state for a specific brand
  const getBrandPagination = (brandId) => {
    return brandPagination[brandId] || { page: 0, rowsPerPage: 10 };
  };
  
  // Update pagination for a specific brand
  const updateBrandPagination = (brandId, newState) => {
    setBrandPagination(prev => ({
      ...prev,
      [brandId]: { ...getBrandPagination(brandId), ...newState }
    }));
  };
  
  // Handle page change for brand pagination
  const handleBrandPageChange = (brandId, newPage) => {
    updateBrandPagination(brandId, { page: newPage });
  };
  
  // Handle rows per page change for brand pagination
  const handleBrandRowsPerPageChange = (brandId, event) => {
    updateBrandPagination(brandId, { 
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    });
  };
  
  // Get paginated products for a brand
  const getPaginatedProducts = (products, brandId) => {
    const { page, rowsPerPage } = getBrandPagination(brandId);
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return products.slice(startIndex, endIndex);
  };
  
  // Load products and related data
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        // Load brands
        const { data: brandsData, error: brandsError } = await supabase
          .from('brands')
          .select('*')
          .eq('company_id', companyId);
          
        if (brandsError) throw brandsError;
        setBrands(brandsData || []);
        
        // Load categories
        const { data: categoriesData, error: categoriesError } = await supabase
          .from('product_categories')
          .select('*')
          .eq('company_id', companyId);
          
        if (categoriesError) throw categoriesError;
        setCategories(categoriesData || []);
        
        // Load products with related data
        const { data: productsData, error: productsError } = await supabase
          .from('products')
          .select(`
            *,
            brand:brand_id(id, name),
            category:category_id(id, name),
            variants:product_variants(*)
          `)
          .eq('company_id', companyId);
          
        if (productsError) throw productsError;
        setProducts(productsData || []);
        setFilteredProducts(productsData || []);
        
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load products. Please try again.');
      } finally {
        setLoading(false);
      }
    }
    
    fetchData();
    fetchCompanyData();
  }, [companyId]);

  const fetchCompanyData = async () => {
    try {
      const { data, error } = await supabase
        .from('companies')
        .select('name')
        .eq('id', companyId)
        .single();

      if (error) throw error;

      if (data) {
        setCompanyName(data.name);
      }
    } catch (err) {
      console.error('Error fetching company data:', err);
      setCompanyName('Company Name');
    }
  };

  // Filter functions for dialogs
  const getFilteredBrands = () => {
    if (!brandSearchTerm.trim()) return brands;
    
    const searchTerm = brandSearchTerm.toLowerCase();
    return brands.filter(brand => 
      brand.name?.toLowerCase().includes(searchTerm)
    );
  };

  const getFilteredCategories = () => {
    if (!categorySearchTerm.trim()) return categories;
    
    const searchTerm = categorySearchTerm.toLowerCase();
    return categories.filter(category => 
      category.name?.toLowerCase().includes(searchTerm)
    );
  };

  // Filter functions for the filter dialogs (separate from product creation dialogs)
  const getFilteredBrandsForFilter = () => {
    if (!brandFilterSearchTerm.trim()) return brands;
    
    const searchTerm = brandFilterSearchTerm.toLowerCase();
    return brands.filter(brand => 
      brand.name?.toLowerCase().includes(searchTerm)
    );
  };

  const getFilteredCategoriesForFilter = () => {
    if (!categoryFilterSearchTerm.trim()) return categories;
    
    const searchTerm = categoryFilterSearchTerm.toLowerCase();
    return categories.filter(category => 
      category.name?.toLowerCase().includes(searchTerm)
    );
  };

  // Handle brand selection from dialog
  const handleBrandSelection = (brandId) => {
    setNewProduct(prev => ({ ...prev, brand_id: brandId }));
    setBrandDialogOpen(false);
    setBrandSearchTerm('');
  };

  // Handle category selection from dialog
  const handleCategorySelection = (categoryId) => {
    setNewProduct(prev => ({ ...prev, category_id: categoryId }));
    setCategoryDialogOpen(false);
    setCategorySearchTerm('');
  };

  // Handle brand filter selection from filter dialog
  const handleBrandFilterSelection = (brandId) => {
    setSelectedBrand(brandId);
    setBrandFilterDialogOpen(false);
    setBrandFilterSearchTerm('');
  };

  // Handle category filter selection from filter dialog
  const handleCategoryFilterSelection = (categoryId) => {
    setSelectedCategory(categoryId);
    setCategoryFilterDialogOpen(false);
    setCategoryFilterSearchTerm('');
  };
  
  // Add this effect to load formulation ingredients when a formulation is selected
  useEffect(() => {
    async function loadFormulationIngredients() {
      if (!viewFormulation) return;
      
      try {
        const { data, error } = await supabase
          .from('formulation_ingredients_new')
          .select(`
            *,
            ingredient:ingredient_id(id, name, inci_name)
          `)
          .eq('formulation_id', viewFormulation.id);
          
        if (error) throw error;
        setFormulationIngredients(data || []);
      } catch (error) {
        console.error('Error loading formulation ingredients:', error);
        setError('Could not load formulation ingredients');
      }
    }
    
    loadFormulationIngredients();
  }, [viewFormulation]);
  
  // Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = value;
    
    if (type !== 'checkbox' && typeof value === 'string') {
      // Don't allow values that are only whitespace
      if (value.trim() === '' && value !== '') {
        return; // Reject whitespace-only input
      }
      processedValue = value;
    }
    
    setNewProduct(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : processedValue
    }));
    
    // If SKU changed, regenerate all variant SKUs
    if (name === 'sku' && processedValue) {
      const updatedVariants = variants.map(variant => {
        if (variant.volume_weight && variant.volume_unit) {
          return {
            ...variant,
            sku: generateVariantSku(processedValue, variant.volume_weight, variant.volume_unit)
          };
        }
        return variant;
      });
      setVariants(updatedVariants);
    }
  };
  
  // Handle multi-select changes (like certifications)
  const handleMultiSelectChange = (field, newValue) => {
    // For arrays, filter out empty/whitespace-only strings
    let processedValue = newValue;
    if (Array.isArray(newValue)) {
      processedValue = newValue.filter(item => 
        typeof item !== 'string' || (typeof item === 'string' && item.trim().length > 0)
      );
    } else if (typeof newValue === 'string' && newValue.trim() === '' && newValue !== '') {
      return; // Reject whitespace-only input
    }
    
    setNewProduct(prev => ({
      ...prev,
      [field]: processedValue
    }));
  };
  
  // Handle product creation without image upload
  const handleSubmitProduct = async () => {
    // Check permissions before proceeding
    if (!hasPermission('products.catalog.edit', 'write')) {
      setError('You do not have permission to create or edit products.');
      return;
    }

    try {
      if (!newProduct.name.trim()) {
        setError('Product name is required');
        return;
      }

      if (!companyId) {
        setError('No company selected');
        return;
      }
      
      // Prepare product data
      const productData = {
        company_id: companyId,
        name: newProduct.name,
        sku: newProduct.sku || null,
        barcode: newProduct.barcode || null,
        description: newProduct.description || null,
        default_price: parseFloat(newProduct.default_price) || null,  // Changed from retail_price
        cost_price: parseFloat(newProduct.cost_price) || null,
        volume_weight: parseFloat(newProduct.volume_weight) || null,
        volume_unit: newProduct.volume_unit || null,
        pack_quantity: parseInt(newProduct.pack_quantity) || 1,
        brand_id: newProduct.brand_id || null,
        category_id: newProduct.category_id || null,
        ingredients: newProduct.ingredients || null,
        skin_type: newProduct.skin_type || null,
        skin_concerns: newProduct.skin_concerns || [],
        certifications: newProduct.certifications || [],
        ph_level: newProduct.ph_level || null,
        benefits: newProduct.benefits || null,
        active_ingredients: newProduct.active_ingredients || null,
        packaging_details: newProduct.packaging_details || null,
        application_instructions: newProduct.application_instructions || null,
        fragrance: newProduct.fragrance || false,
        allergens: newProduct.allergens || null,
        shelf_life_months: newProduct.shelf_life_months ? parseInt(newProduct.shelf_life_months) : null,
        product_code: newProduct.product_code || null,
        product_type: newProduct.product_type && newProduct.product_type.trim() !== '' ? newProduct.product_type : 'In-House',
        status: newProduct.status && newProduct.status.trim() !== '' ? newProduct.status : 'Active',
        packaging_used: newProduct.packaging_used || null,
        label_version: newProduct.label_version || null,
        launch_date: newProduct.launch_date || null,
        has_variants: variants.length > 0,
        is_active: newProduct.is_active
      };

      // Handle update vs. insert for the base product
      let productResult;
      if (editingProduct) {
        const { data, error } = await supabase
          .from('products')
          .update(productData)
          .eq('id', editingProduct.id)
          .select();
        
        if (error) {
          console.error('Supabase update error:', error);
          throw error;
        }
        
        productResult = data[0];
      } else {
        const { data, error } = await supabase
          .from('products')
          .insert([productData])
          .select();
        
        if (error) {
          console.error('Supabase insert error:', error);
          throw error;
        }
        
        productResult = data[0];
        setSuccess('Product added successfully');
      }

      // Handle variant deletions if editing product
      if (editingProduct && originalVariants.length > 0) {
        // Find variants that were deleted (exist in original but not in current)
        const currentVariantIds = variants.filter(v => v.id && !v.id.includes('temp-')).map(v => v.id);
        const deletedVariants = originalVariants.filter(v => v.id && !v.id.includes('temp-') && !currentVariantIds.includes(v.id));
        
        // Delete removed variants from database
        for (const deletedVariant of deletedVariants) {
          await supabase
            .from('product_variants')
            .delete()
            .eq('id', deletedVariant.id);
        }
      }

      // Handle variants if any
      if (variants.length > 0) {
        // Flag the product as having variants
        await supabase
          .from('products')
          .update({ has_variants: true })
          .eq('id', productResult.id);
        
        // Sort variants by size before saving (largest to smallest)
        const sortedVariants = sortVariantsBySize(variants);
        
        // Process each variant
        for (const variant of sortedVariants) {
          // Calculate profit margin one more time before saving to ensure it's up to date
          const retailPrice = parseFloat(variant.price) || 0;
          const costPrice = parseFloat(variant.cost_price) || 0;
          const profitMargin = calculateProfitMargin(retailPrice, costPrice);
          
          const variantData = {
            product_id: productResult.id,
            name: variant.volume_weight ? `${variant.volume_weight}${variant.volume_unit}` : 'Default',
            sku: variant.sku || null,
            barcode: variant.barcode || null,
            price: parseFloat(variant.price) || 0,
            cost_price: parseFloat(variant.cost_price) || 0,
            single_unit_cost: parseFloat(variant.single_unit_cost) || 0,
            unit_price: parseFloat(variant.unit_price) || 0,
            volume_weight: parseFloat(variant.volume_weight) || null,
            volume_unit: variant.volume_unit || null,
            pack_quantity: parseInt(variant.pack_quantity) || 1,
            attributes: { profit_margin: profitMargin }
          };
          
          // If editing and variant has ID, update it
          if (editingProduct && variant.id && !variant.id.includes('temp-')) {
            await supabase
              .from('product_variants')
              .update(variantData)
              .eq('id', variant.id);
          } else {
            // Otherwise insert new variant
            await supabase
              .from('product_variants')
              .insert([variantData]);
          }
        }
      } else if (editingProduct) {
        // If no variants and this is an edit, set has_variants to false
        await supabase
          .from('products')
          .update({ has_variants: false })
          .eq('id', productResult.id);
      }

      setSuccess(editingProduct ? 'Product updated successfully' : 'Product added successfully');
      setShowForm(false);
      setEditingProduct(null);
      setNewProduct(createEmptyProduct());
      setVariants([]);
      setOriginalVariants([]);
      setActiveStep(0); // Reset stepper
      
      // Fetch all products to refresh the list
      await fetchAllData();
      
    } catch (error) {
      console.error('Error saving product:', error);
      setError(`Error saving product: ${error.message}`);
    }
  };
  
  // Reload products after saving
  const fetchAllData = async () => {
    setLoading(true);
    try {
      
      // Load brands
      const { data: brandsData, error: brandsError } = await supabase
        .from('brands')
        .select('*')
        .eq('company_id', companyId);
        
      if (brandsError) throw brandsError;
      setBrands(brandsData || []);
      
      // Load categories
      const { data: categoriesData, error: categoriesError } = await supabase
        .from('product_categories')
        .select('*')
        .eq('company_id', companyId);
        
      if (categoriesError) throw categoriesError;
      setCategories(categoriesData || []);
      
      // Load products with related data - force cache refresh
      const { data: productsData, error: productsError } = await supabase
        .from('products')
        .select(`
          *,
          brand:brand_id(id, name),
          category:category_id(id, name),
          variants:product_variants(*)
        `)
        .eq('company_id', companyId);
        
      if (productsError) throw productsError;
      
      // Process products to fix image URLs if needed
      const processedProducts = productsData.map(product => {
        if (product.image_url && !product.image_url.includes('/storage/v1/object/public/')) {
          // If URL doesn't have the correct format, reconstruct it
          const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
          // Extract the path from the URL
          const urlPath = product.image_url.split('product-images/').pop();
          if (urlPath) {
            product.image_url = `${supabaseUrl}/storage/v1/object/public/product-images/${urlPath}`;
          }
        }
        return product;
      });
      
      // Log all image URLs for debugging
      if (processedProducts && processedProducts.length > 0) {
        processedProducts.forEach(p => {
          if (p.image_url) {
          }
          
          // Log variant data
          if (p.variants && p.variants.length > 0) {
            p.variants.forEach(v => {
            });
          }
        });
      }
      
      setProducts(processedProducts || []);
      setFilteredProducts(processedProducts || []);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to reload products. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  // Replace the useEffect for loading data to use this function
  useEffect(() => {
    fetchAllData();
  }, [companyId]);
  
  // Delete product
  const handleDeleteProduct = async () => {
    if (!confirmDelete) return;
    
    // Check permissions before proceeding
    if (!hasPermission('products.catalog.delete', 'delete')) {
      setError('You do not have permission to delete products.');
      setConfirmDelete(null);
      return;
    }
    
    try {
      const { error } = await supabase
        .from('products')
        .delete()
        .eq('id', confirmDelete.id);
        
      if (error) throw error;
      
      // Remove from products list
      setProducts(prev => prev.filter(p => p.id !== confirmDelete.id));
      setFilteredProducts(prev => prev.filter(p => p.id !== confirmDelete.id));
      setSuccess('Product deleted successfully');
      
    } catch (error) {
      console.error('Error deleting product:', error);
      setError('Failed to delete product. Please try again.');
    } finally {
      setConfirmDelete(null);
    }
  };
  
  // Add this useEffect to trigger filtering when filters change
  useEffect(() => {
    filterProducts();
  }, [products, selectedBrand, selectedCategory, filters.search, filters.skinType, filters.inStock]);
  
  // Update the filterProducts function with improved logic
  const filterProducts = () => {
    let filtered = [...products];
    
    // Apply search filter first for better performance
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filtered = filtered.filter(p => 
        (p.name && p.name.toLowerCase().includes(searchLower)) ||
        (p.description && p.description.toLowerCase().includes(searchLower)) ||
        (p.sku && p.sku.toLowerCase().includes(searchLower)) ||
        (p.ingredients && p.ingredients.toLowerCase().includes(searchLower)) ||
        (p.brand && p.brand.name && p.brand.name.toLowerCase().includes(searchLower)) ||
        (p.category && p.category.name && p.category.name.toLowerCase().includes(searchLower))
      );
    }
    
    // Apply brand filter - FIXED: Handle both string and numeric IDs
    if (selectedBrand !== 'all') {
      filtered = filtered.filter(p => {
        if (!p.brand) return false;
        
        // Convert both values to strings for comparison to handle type mismatches
        const productBrandId = String(p.brand.id);
        const selectedBrandId = String(selectedBrand);
        
        return productBrandId === selectedBrandId;
      });
    }
    
    // Apply category filter - FIXED: Handle both string and numeric IDs
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(p => {
        if (!p.category) return false;
        
        // Convert both values to strings for comparison to handle type mismatches
        const productCategoryId = String(p.category.id);
        const selectedCategoryId = String(selectedCategory);
        
        return productCategoryId === selectedCategoryId;
      });
    }
    
    // Apply skin type filter
    if (filters.skinType !== 'all') {
      filtered = filtered.filter(p => p.skin_type === filters.skinType);
    }
    
    // Apply in-stock filter
    if (filters.inStock) {
      filtered = filtered.filter(p => {
        // This would connect to your inventory system
        return true; // Placeholder
      });
    }
    
    // Sort by product_code (RBE-001, RBE-002, etc.) - alphanumeric natural sort
    filtered.sort((a, b) => {
      const codeA = a.product_code || '';
      const codeB = b.product_code || '';
      return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
    });
    
    setFilteredProducts(filtered);
  };
  
  // Add this function to organize products by brand when viewing "All Brands"
  const getOrganizedProducts = () => {
    // Group products by brand
    const productsByBrand = {};
    filteredProducts.forEach(product => {
      const brandId = product.brand_id || 'unbranded';
      if (!productsByBrand[brandId]) {
        productsByBrand[brandId] = [];
      }
      productsByBrand[brandId].push(product);
    });
    
    // Get brand info for each group
    const organizedProducts = Object.keys(productsByBrand).map(brandId => {
      const brandProducts = productsByBrand[brandId];
      const brand = brandId === 'unbranded' 
        ? { id: 'unbranded', name: 'Unbranded Products' } 
        : brands.find(b => b.id === brandId) || { id: brandId, name: 'Unknown Brand' };
      
      // Sort products within each brand by product_code - alphanumeric natural sort
      brandProducts.sort((a, b) => {
        const codeA = a.product_code || '';
        const codeB = b.product_code || '';
        return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
      });
      
      return {
        brand,
        products: brandProducts
      };
    });
    
    // Sort by brand name
    organizedProducts.sort((a, b) => a.brand.name.localeCompare(b.brand.name));
    
    return { organized: true, groupedProducts: organizedProducts };
  };
  
  // Fix the handleEditProduct function
  const handleEditProduct = (product) => {
    setEditingProduct(product);
    setCurrentTab(0);
    
    const editableProduct = {
      ...product,
      volume_weight: product.volume_weight || '',
      default_price: product.default_price || '',
      cost_price: product.cost_price || '',
      pack_quantity: product.pack_quantity || 1,
      brand_id: product.brand_id || '',
      category_id: product.category_id || '',
      certifications: product.certifications || [],
      product_code: product.product_code || '',
      product_type: product.product_type || 'In-House',
      status: product.status || 'Active',
      packaging_used: product.packaging_used || '',
      label_version: product.label_version || '',
      launch_date: product.launch_date || '',
    };
    
    setNewProduct(editableProduct);
    
    // Set variants if they exist in the product and convert price fields as needed
    if (product.variants && Array.isArray(product.variants)) {
      // Make sure variant data has consistent field names
      const fixedVariants = product.variants.map(variant => {
        // Calculate profit margin for each variant
        const retailPrice = parseFloat(variant.price) || 0;
        const costPrice = parseFloat(variant.cost_price) || 0;
        const profitMargin = calculateProfitMargin(retailPrice, costPrice);
        
        return {
          ...variant,
          // Use price as the primary field, fallback to default_price if needed
          price: variant.price || variant.default_price || '',
          single_unit_cost: variant.single_unit_cost || '',
          profit_margin: variant.attributes?.profit_margin || profitMargin
        };
      });
      // Sort variants by size when loading (largest to smallest)
      const sortedVariants = sortVariantsBySize(fixedVariants);
      setVariants(sortedVariants);
      setOriginalVariants([...sortedVariants]); // Save original variants for tracking deletions
    } else {
      setVariants([]); // Reset variants if none exist
      setOriginalVariants([]);
    }
    
    setShowForm(true);
  };
  
  // Duplicate product
  const handleDuplicateProduct = (product) => {
    setNewProduct({
      name: `${product.name} (Copy)`,
      brand_id: product.brand_id || '',
      category_id: product.category_id || '',
      sku: `${product.sku}-COPY` || '',
      description: product.description || '',
      volume_weight: product.volume_weight || '',
      volume_unit: product.volume_unit || 'ml',
      default_price: product.default_price || '',
      cost_price: product.cost_price || '',
      pack_quantity: product.pack_quantity || 1,
      shelf_life_months: product.shelf_life_months || '',
      
      // Formulation tab
      benefits: product.benefits || '',
      active_ingredients: product.active_ingredients || '',
      ph_level: product.ph_level || '',
      fragrance: product.fragrance || false,
      
      // Ingredients & Certifications tab
      ingredients: product.ingredients || '',
      skin_type: product.skin_type || '',
      certifications: product.certifications || [],
      allergens: product.allergens || '',
      packaging_details: product.packaging_details || '',
      
      // Application Instructions tab
      application_instructions: product.application_instructions || '',
      
      // New required fields
      product_code: `${product.product_code}-COPY` || '',
      product_type: product.product_type || 'In-House',
      status: product.status || 'Active',
      packaging_used: product.packaging_used || '',
      label_version: product.label_version || '',
      launch_date: product.launch_date || '',
      is_active: product.is_active || true,
    });
    
    setShowForm(true);
  };
  
  // Add this function to handle viewing a formulation
  const handleViewFormulation = async (productId) => {
    try {
      // Load the latest formulation for this product
      const { data, error } = await supabase
        .from('product_formulations')
        .select(`
          *,
          product:product_id(id, name)
        `)
        .eq('product_id', productId)
        .order('created_at', { ascending: false })
        .limit(1);
        
      if (error) throw error;
      if (data && data.length > 0) {
        setViewFormulation(data[0]);
      } else {
        setError('No formulation found for this product');
      }
    } catch (error) {
      console.error('Error loading formulation:', error);
      setError('Could not load formulation details');
    }
  };
  
  // Function to handle category creation
  const handleSubmitCategory = async () => {
    if (!newCategory.name.trim()) {
      setError('Category name is required');
      return;
    }

    try {
      const { data, error } = await supabase
        .from('product_categories')
        .insert([{
          company_id: companyId,
          ...newCategory
        }])
        .select();

      if (error) throw error;

      // Add the new category to the categories list
      setCategories([...categories, data[0]]);
      
      // If creating from product form, select the category
      if (showForm) {
        setNewProduct({
          ...newProduct,
          category_id: data[0].id
        });
      }
      
      setShowCategoryForm(false);
      setNewCategory({
        name: '',
        description: '',
        parent_id: null,
      });
      setSuccess('Category created successfully');
    } catch (error) {
      console.error('Error creating category:', error);
      setError(error.message || 'Error creating category');
    }
  };
  
  // Fix 3: When setting up new product form, use the clean function
  // Find this in your code and replace it
  const handleAddNewProduct = () => {
    setNewProduct(createEmptyProduct());
    setEditingProduct(null);
    setVariants([]);
    setOriginalVariants([]);
    setActiveStep(0); // Reset stepper
    setShowForm(true);
  };

  // Fix 4: When canceling, use the clean function
  // Find this in your code and replace it
  const handleCancelForm = () => {
    setShowForm(false);
    setEditingProduct(null);
    setNewProduct(createEmptyProduct());
    setVariants([]);
    setOriginalVariants([]);
    setActiveStep(0); // Reset stepper
  };

  // Stepper navigation functions
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const isStepValid = (step) => {
    const isValidString = (value) => value && typeof value === 'string' && value.trim().length > 0;
    const isValidNumber = (value) => value && (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '' && !isNaN(Number(value.trim()))));
    
    switch (step) {
      case 0: // Basic Information
        return isValidString(newProduct.name) &&
               isValidString(newProduct.sku) &&
               isValidString(newProduct.brand_id) &&
               isValidString(newProduct.product_code) &&
               isValidString(newProduct.product_type) &&
               isValidString(newProduct.status) &&
               isValidString(newProduct.launch_date);
      case 1: // Product Variants
        if (!variants || variants.length === 0) {
          return false;
        }
        return variants.every(variant => 
          isValidNumber(variant.volume_weight) &&
          isValidString(variant.volume_unit) &&
          isValidNumber(variant.pack_quantity) &&
          isValidString(variant.barcode) &&
          isValidNumber(variant.price) &&
          isValidNumber(variant.cost_price) &&
          isValidNumber(variant.single_unit_cost)
        );
      case 2: // Formulation Details
        return isValidNumber(newProduct.shelf_life_months) &&
               isValidString(newProduct.ph_level) &&
               isValidString(newProduct.benefits) &&
               isValidString(newProduct.active_ingredients);
      case 3: // Ingredients & Certifications
        return isValidString(newProduct.ingredients) &&
               isValidString(newProduct.skin_type) &&
               newProduct.certifications && newProduct.certifications.length > 0 &&
               isValidString(newProduct.allergens);
      case 4: // Application Instructions
        return isValidString(newProduct.application_instructions);
      default:
        return false;
    }
  };
  
  // Replace the ProductImage component with a simple placeholder
  const ProductImage = () => {
    return (
      <Box 
        sx={{ 
          width: '100%', 
          height: '100%', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f5f5f5',
          color: '#999'
        }}
      >
        <Typography variant="caption">No Image</Typography>
      </Box>
    );
  };
  
  // Handle clicking on a product to view details
  const handleViewProduct = (product) => {
    setViewingProduct(product);
    setViewTab(0);
    setShowViewDialog(true);
  };
  
  // Add a new variant
  const addVariant = () => {
    // Default values for new variant
    const newVariant = {
      volume_weight: '',
      volume_unit: 'ml',
      pack_quantity: 1,
      price: '',
      cost_price: '',
      single_unit_cost: '',
      unit_price: '',
      profit_margin: '0',
      barcode: '',
      sku: ''
    };
    
    // Don't sort when adding - only sort when saving
    setVariants([...variants, newVariant]);
  };
  
  // Update a variant field
  const updateVariant = (index, field, value) => {
    // Don't allow values that are only whitespace
    if (typeof value === 'string' && value.trim() === '' && value !== '') {
      return; // Reject whitespace-only input
    }
    
    const updatedVariants = [...variants];
    updatedVariants[index] = {
      ...updatedVariants[index],
      [field]: value
    };
    
    // Auto-regenerate SKU when volume or unit changes
    if (field === 'volume_weight' || field === 'volume_unit') {
      const variant = updatedVariants[index];
      if (newProduct.sku && variant.volume_weight && variant.volume_unit) {
        updatedVariants[index].sku = generateVariantSku(
          newProduct.sku,
          variant.volume_weight,
          variant.volume_unit
        );
      }
    }
    
    // Update profit margin when price or cost price changes
    if (field === 'price' || field === 'cost_price') {
      const retailPrice = parseFloat(updatedVariants[index].price) || 0;
      const costPrice = parseFloat(updatedVariants[index].cost_price) || 0;
      updatedVariants[index].profit_margin = calculateProfitMargin(retailPrice, costPrice);
    }
    
    // Don't sort while editing - only sort when saving
    setVariants(updatedVariants);
  };
  
  // Remove a variant
  const removeVariant = (index) => {
    const updatedVariants = [...variants];
    updatedVariants.splice(index, 1);
    setVariants(updatedVariants);
  };

  // Sort variants by size (largest to smallest) based on volume_weight number
  const sortVariantsBySize = (variantsToSort) => {
    return [...variantsToSort].sort((a, b) => {
      const numA = parseFloat(a.volume_weight) || 0;
      const numB = parseFloat(b.volume_weight) || 0;
      return numB - numA; // Descending order (largest first)
    });
  };
  
  // Generate SKU for variants based on product SKU and variant attributes
  const generateVariantSku = (productSku, volume, unit) => {
    // Format volume and unit (uppercase, no spaces)
    const formattedUnit = unit.toUpperCase().replace(/\s+/g, '');
    const variantPart = `${volume}${formattedUnit}`;
    
    // Combine parts with hyphen: SKU-{amount}
    return `${productSku}-${variantPart}`;
  };

  // Step content components
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return renderBasicInfoStep();
      case 1:
        return renderVariantsStep();
      case 2:
        return renderFormulationStep();
      case 3:
        return renderIngredientsStep();
      case 4:
        return renderApplicationStep();
      default:
        return null;
    }
  };

  const renderBasicInfoStep = () => (
    <StepContentBox>
      <Typography variant="h6" sx={{ 
        fontWeight: 500, 
        mb: 3, 
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <InfoOutlinedIcon />
        Basic Product Information
      </Typography>
      <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="product-name-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Product Name *
            </InputLabel>
            <OutlinedInput
              id="product-name-input"
              fullWidth
              name="name"
              value={newProduct.name}
              onChange={handleChange}
              required
              error={!newProduct.name}
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.name && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Product name is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="sku-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              SKU *
            </InputLabel>
            <OutlinedInput
              id="sku-input"
              fullWidth
              name="sku"
              value={newProduct.sku}
              onChange={handleChange}
              required
              error={!newProduct.sku}
              placeholder="e.g. CLE-001"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.sku && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                SKU is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.brand_id}>
            <InputLabel 
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(0, -1.5px) scale(0.75)',
                transformOrigin: 'top left'
              }}
            >
              Brand *
            </InputLabel>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setBrandDialogOpen(true)}
              sx={{
                height: 56,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                background: alpha(theme.palette.background.paper, 0.8),
                justifyContent: 'flex-start',
                px: 3,
                py: 2.5,
                mt: 2,
                color: newProduct.brand_id ? 'text.primary' : 'text.secondary',
                '&:hover': {
                  border: `1px solid ${theme.palette.primary.main}`,
                  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                }
              }}
            >
              {newProduct.brand_id ? 
                brands.find(brand => brand.id === newProduct.brand_id)?.name || 'Select Brand' : 
                'Select Brand'
              }
            </Button>
            {!newProduct.brand_id && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Brand is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(0, -1.5px) scale(0.75)',
                transformOrigin: 'top left'
              }}
            >
              Category
            </InputLabel>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setCategoryDialogOpen(true)}
              sx={{
                height: 56,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                background: alpha(theme.palette.background.paper, 0.8),
                justifyContent: 'flex-start',
                px: 3,
                py: 2.5,
                mt: 2,
                color: newProduct.category_id ? 'text.primary' : 'text.secondary',
                '&:hover': {
                  border: `1px solid ${theme.palette.primary.main}`,
                  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                }
              }}
            >
              {newProduct.category_id ? 
                categories.find(category => category.id === newProduct.category_id)?.name || 'Select Category' : 
                'Select Category'
              }
            </Button>
            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                size="small" 
                onClick={() => setShowCategoryForm(true)}
                startIcon={<AddIcon />}
              >
                Add New Category
              </Button>
            </Box>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="description-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Product Description
            </InputLabel>
            <OutlinedInput
              id="description-input"
              fullWidth
              name="description"
              value={newProduct.description}
              onChange={handleChange}
              multiline
              rows={15}
              placeholder="Describe your product"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="product-code-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Product Code *
            </InputLabel>
            <OutlinedInput
              id="product-code-input"
              fullWidth
              name="product_code"
              value={newProduct.product_code}
              onChange={handleChange}
              required
              error={!newProduct.product_code}
              placeholder="e.g. PC-001"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.product_code && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Product code is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.product_type}>
            <InputLabel 
              htmlFor="product-type-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem'
              }}
            >
              Product Type *
            </InputLabel>
            <Select
              id="product-type-input"
              name="product_type"
              value={newProduct.product_type}
              onChange={handleChange}
              label="Product Type *"
              required
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8)
              }}
            >
              <MenuItem value="In-House">In-House</MenuItem>
              <MenuItem value="Private Label">Private Label</MenuItem>
            </Select>
            {!newProduct.product_type && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Product type is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.status}>
            <InputLabel 
              htmlFor="status-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem'
              }}
            >
              Status *
            </InputLabel>
            <Select
              id="status-input"
              name="status"
              value={newProduct.status}
              onChange={handleChange}
              label="Status *"
              required
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8)
              }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Discontinued">Discontinued</MenuItem>
              <MenuItem value="R&D">R&D</MenuItem>
            </Select>
            {!newProduct.status && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Status is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="packaging-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Packaging Used
            </InputLabel>
            <OutlinedInput
              id="packaging-input"
              fullWidth
              name="packaging_used"
              value={newProduct.packaging_used}
              onChange={handleChange}
              placeholder="e.g. Glass bottle, Plastic tube"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              htmlFor="label-version-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Label Version
            </InputLabel>
            <OutlinedInput
              id="label-version-input"
              fullWidth
              name="label_version"
              value={newProduct.label_version}
              onChange={handleChange}
              placeholder="e.g. v1.0, v2.1"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Launch Date *"
            value={newProduct.launch_date ? dayjs(newProduct.launch_date) : null}
            onChange={(newValue) => setNewProduct(prev => ({
              ...prev,
              launch_date: newValue ? newValue.format('YYYY-MM-DD') : ''
            }))}
            slotProps={{
              textField: {
                required: true,
                error: !newProduct.launch_date,
                helperText: !newProduct.launch_date ? "Launch date is required" : ""
              }
            }}
            sx={{ 
              width: '100%',
              '& .MuiOutlinedInput-root': { 
                borderRadius: 2,
                bgcolor: 'white'
              }
            }}
          />
        </Grid>
      </Grid>
    </StepContentBox>
  );

  const renderVariantsStep = () => (
    <StepContentBox>
      <Typography variant="h6" sx={{ 
        fontWeight: 500, 
        mb: 3, 
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <InventoryIcon />
        Product Variants
      </Typography>

      {variants.length > 0 && variants.map((variant, index) => (
        <Paper key={index} sx={{ 
          p: 3, 
          mb: 3, 
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'grey.200'
        }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            mb: 2
          }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Variant {index + 1}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton color="error" onClick={() => removeVariant(index)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 2, color: 'primary.main' }}>
                Product Information:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`volume-weight-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Volume/Weight
                </InputLabel>
                <OutlinedInput
                  id={`volume-weight-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.volume_weight}
                  onChange={(e) => updateVariant(index, 'volume_weight', e.target.value)}
                  placeholder="e.g. 50"
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FormControl fullWidth>
                <InputLabel>Unit</InputLabel>
                <Select
                  value={variant.volume_unit}
                  onChange={(e) => updateVariant(index, 'volume_unit', e.target.value)}
                  label="Unit"
                  sx={{
                    borderRadius: 2,
                    bgcolor: 'white'
                  }}
                >
                  {volumeUnits.map(unit => (
                    <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`pack-quantity-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Units per Case
                </InputLabel>
                <OutlinedInput
                  id={`pack-quantity-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.pack_quantity}
                  onChange={(e) => updateVariant(index, 'pack_quantity', e.target.value)}
                  placeholder="e.g. 12"
                  inputProps={{ min: 1 }}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Number of individual units in a case
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`barcode-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Barcode
                </InputLabel>
                <OutlinedInput
                  id={`barcode-input-${index}`}
                  fullWidth
                  value={variant.barcode}
                  onChange={(e) => updateVariant(index, 'barcode', e.target.value)}
                  placeholder="e.g. 123456789012"
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`sku-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  SKU
                </InputLabel>
                <OutlinedInput
                  id={`sku-input-${index}`}
                  fullWidth
                  value={variant.sku || ''}
                  placeholder="Auto-generated"
                  readOnly
                  sx={{
                    borderRadius: 3,
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Auto-generated from product name and size
                </Typography>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 2, mt: 2, color: 'primary.main' }}>
                Product Pricing
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`price-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Case Price
                </InputLabel>
                <OutlinedInput
                  id={`price-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.price}
                  onChange={(e) => updateVariant(index, 'price', e.target.value)}
                  startAdornment={<Box component="span" sx={{ mr: 1}}>$</Box>}
                  inputProps={{ step: 0.01, min: 0 }}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Price for entire pack/case
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`unit-price-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Unit Price
                </InputLabel>
                <OutlinedInput
                  id={`unit-price-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.unit_price}
                  onChange={(e) => updateVariant(index, 'unit_price', e.target.value)}
                  startAdornment={<Box component="span" sx={{ mr: 1 }}>$</Box>}
                  inputProps={{ step: 0.01, min: 0 }}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Price per individual unit
                </Typography>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 2, mt: 2, color: 'primary.main' }}>
                Product Cost
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`cost-price-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Case Cost Price
                </InputLabel>
                <OutlinedInput
                  id={`cost-price-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.cost_price}
                  onChange={(e) => updateVariant(index, 'cost_price', e.target.value)}
                  startAdornment={<Box component="span" sx={{ mr: 1 }}>$</Box>}
                  inputProps={{ step: 0.01, min: 0 }}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Cost for entire pack/case
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`single-unit-cost-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Single Unit Cost
                </InputLabel>
                <OutlinedInput
                  id={`single-unit-cost-input-${index}`}
                  fullWidth
                  type="number"
                  value={variant.single_unit_cost}
                  onChange={(e) => updateVariant(index, 'single_unit_cost', e.target.value)}
                  startAdornment={<Box component="span" sx={{ mr: 1 }}>$</Box>}
                  inputProps={{ step: 0.01, min: 0 }}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Cost per individual unit for inventory valuation
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel 
                  htmlFor={`profit-margin-input-${index}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: '1rem',
                    transform: 'translate(14px, 1px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                      transform: 'translate(14px, -17px) scale(0.75)'
                    }
                  }}
                >
                  Profit Margin
                </InputLabel>
                <OutlinedInput
                  id={`profit-margin-input-${index}`}
                  fullWidth
                  value={`${variant.profit_margin || '0'}%`}
                  readOnly
                  sx={{
                    borderRadius: 3,
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${theme.palette.primary.main}`
                    }
                  }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 2 }}>
                  Auto-calculated from price and cost
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      ))}

      {variants.length > 0 && (
        <Box sx={{ mt: 3, mb: 3 }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={addVariant}
            sx={{
              borderRadius: 2,
              borderColor: 'grey.400',
              color: 'primary.main',
              borderWidth: 1,
              fontWeight: 500,
              px: 3,
              py: 1.5,
              background: 'white',
              border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
              '&:hover': {
                borderColor: 'grey.600',
                backgroundColor: 'white',
                transform: 'translateY(-1px)',
                boxShadow: `0 4px 12px ${alpha(theme.palette.grey[400], 0.25)}`
              }
            }}
          >
            Add Another Variant
          </Button>
        </Box>
      )}

      {variants.length === 0 && (
        <Box sx={{ 
          p: 4, 
          textAlign: 'center',
          bgcolor: 'grey.50',
          borderRadius: 2,
          border: '2px dashed',
          borderColor: 'grey.300'
        }}>
          <InventoryIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No variants defined
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add variants to offer different sizes or packaging options
          </Typography>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={addVariant}
            sx={{
              borderRadius: 2,
              borderColor: 'grey.400',
              color: 'primary.main',
              borderWidth: 1,
              fontWeight: 500,
              px: 3,
              py: 1.5,
              background: 'white',
              border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
              '&:hover': {
                borderColor: 'grey.600',
                backgroundColor: 'white',
                transform: 'translateY(-1px)',
                boxShadow: `0 4px 12px ${alpha(theme.palette.grey[400], 0.25)}`
              }
            }}
          >
            Add Your First Variant
          </Button>
        </Box>
      )}
    </StepContentBox>
  );

  const renderFormulationStep = () => (
    <StepContentBox>
      <Typography variant="h6" sx={{ 
        fontWeight: 500, 
        mb: 3, 
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <ScienceIcon />
        Formulation Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.shelf_life_months}>
            <InputLabel 
              htmlFor="shelf-life-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Shelf Life (Months) *
            </InputLabel>
            <OutlinedInput
              id="shelf-life-input"
              fullWidth
              name="shelf_life_months"
              type="number"
              value={newProduct.shelf_life_months}
              onChange={handleChange}
              required
              placeholder="e.g. 24"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.shelf_life_months && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Shelf life is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.ph_level}>
            <InputLabel 
              htmlFor="ph-level-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              pH Level *
            </InputLabel>
            <OutlinedInput
              id="ph-level-input"
              fullWidth
              name="ph_level"
              value={newProduct.ph_level}
              onChange={handleChange}
              required
              placeholder="e.g. 5.5"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.ph_level && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                pH level is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth error={!newProduct.benefits}>
            <InputLabel 
              htmlFor="benefits-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Benefits *
            </InputLabel>
            <OutlinedInput
              id="benefits-input"
              fullWidth
              name="benefits"
              value={newProduct.benefits}
              onChange={handleChange}
              required
              multiline
              rows={15}
              placeholder="Key product benefits"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.benefits && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Benefits are required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth error={!newProduct.active_ingredients}>
            <InputLabel 
              htmlFor="active-ingredients-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Key Active Ingredients *
            </InputLabel>
            <OutlinedInput
              id="active-ingredients-input"
              fullWidth
              name="active_ingredients"
              value={newProduct.active_ingredients}
              onChange={handleChange}
              required
              multiline
              rows={5}
              placeholder="Key active ingredients with percentages"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.active_ingredients && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Active ingredients are required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                name="fragrance"
                checked={newProduct.fragrance}
                onChange={handleChange}
              />
            }
            label="Contains Fragrance"
          />
        </Grid>
      </Grid>
    </StepContentBox>
  );

  const renderIngredientsStep = () => (
    <StepContentBox>
      <Typography variant="h6" sx={{ 
        fontWeight: 500, 
        mb: 3, 
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <FormatListBulletedIcon />
        Ingredients & Certifications
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl fullWidth error={!newProduct.ingredients}>
            <InputLabel 
              htmlFor="ingredients-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Full Ingredients List *
            </InputLabel>
            <OutlinedInput
              id="ingredients-input"
              fullWidth
              name="ingredients"
              value={newProduct.ingredients}
              onChange={handleChange}
              required
              multiline
              rows={15}
              placeholder="Full INCI ingredients list"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.ingredients && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Full ingredients list is required
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required error={!newProduct.skin_type}>
            <InputLabel>Skin Type Compatibility *</InputLabel>
            <Select
              name="skin_type"
              value={newProduct.skin_type}
              onChange={handleChange}
              label="Skin Type Compatibility *"
              sx={{
                borderRadius: 2,
                bgcolor: 'white'
              }}
            >
              {skinTypes.map(type => (
                <MenuItem key={type} value={type}>{type}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            multiple
            options={certifications}
            value={newProduct.certifications}
            onChange={(e, newValue) => handleMultiSelectChange('certifications', newValue)}
            renderInput={(params) => (
              <TextField 
                {...params} 
                required
                label="Certifications *" 
                placeholder="Select all that apply"
                error={!newProduct.certifications || newProduct.certifications.length === 0}
                helperText={(!newProduct.certifications || newProduct.certifications.length === 0) ? "At least one certification is required" : ""}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    bgcolor: 'white'
                  }
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!newProduct.allergens}>
            <InputLabel 
              htmlFor="allergens-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Allergen Information *
            </InputLabel>
            <OutlinedInput
              id="allergens-input"
              fullWidth
              name="allergens"
              value={newProduct.allergens}
              onChange={handleChange}
              required
              placeholder="List common allergens present"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.allergens && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Allergen information is required
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </StepContentBox>
  );

  const renderApplicationStep = () => (
    <StepContentBox>
      <Typography variant="h6" sx={{ 
        fontWeight: 500, 
        mb: 3, 
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <MenuBookIcon />
        Application Instructions
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl fullWidth error={!newProduct.application_instructions}>
            <InputLabel 
              htmlFor="application-instructions-input"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                transform: 'translate(14px, 1px) scale(1)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translate(14px, -17px) scale(0.75)'
                }
              }}
            >
              Application Instructions *
            </InputLabel>
            <OutlinedInput
              id="application-instructions-input"
              fullWidth
              name="application_instructions"
              value={newProduct.application_instructions}
              onChange={handleChange}
              required
              multiline
              rows={15}
              placeholder="How to use this product"
              sx={{
                borderRadius: 3,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.primary.main}`
                }
              }}
            />
            {!newProduct.application_instructions && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                Application instructions are required
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </StepContentBox>
  );

  // Permission check
  if (!hasPermission('products.catalog.view')) {
    return (
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: '70vh',
          textAlign: 'center'
        }}>
          <Card sx={{
            p: 8,
            borderRadius: 3,
            border: `1px solid ${theme.palette.grey[400]}`,
            background: 'white',
            boxShadow: `0 12px 40px ${alpha(theme.palette.grey[900], 0.08)}`,
            maxWidth: 600,
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'default',
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            '&:hover': {
              transform: 'translateY(-8px)',
              boxShadow: `0 20px 60px ${alpha(theme.palette.grey[900], 0.15)}`,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.grey[400]})`,
              opacity: 0.8,
              transition: 'opacity 0.3s ease'
            },
            '&:hover::before': {
              opacity: 1
            }
          }}>
            <Box sx={{ 
              p: 3, 
              borderRadius: 3, 
              background: `linear-gradient(${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.primary.main, 0.02)})`,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
              mb: 6,
              display: 'inline-flex',
              boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.15)}`
            }}>
              <MenuBookIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
            </Box>
            <Typography variant="h3" sx={{ 
              mb: 3, 
              fontWeight: 500, 
              color: 'text.primary',
              fontSize: '2.5rem',
              letterSpacing: '-0.8px'
            }}>
              Access Restricted
            </Typography>
            <Typography variant="h6" sx={{ 
              color: 'text.secondary', 
              mb: 4,
              fontWeight: 500,
              fontSize: '1.2rem'
            }}>
              Product Catalog Permissions Required
            </Typography>
            <Typography variant="body1" sx={{ 
              color: 'text.secondary',
              lineHeight: 1.7,
              mb: 6,
              fontSize: '1.05rem',
              maxWidth: 450,
              mx: 'auto'
            }}>
              You don't currently have the necessary permissions to access the Product Catalog. 
              Contact your system administrator to request access or verify your role permissions.
            </Typography>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                px: 4,
                py: 1.5,
                fontSize: '1rem'
              }}
            >
              Return to Previous Page
            </Button>
          </Card>
        </Box>
      </Container>
    );
  }
  
  // Check edit permissions
  const canEdit = hasPermission('products.catalog.edit', 'write');
  
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Fade in timeout={800}>
        <Box>
        <Container 
          maxWidth="xl"
          sx={{
            py: 3,
            pb: 8,
            px: { xs: 2, sm: 3 },
            width: '100%',
            maxWidth: '100vw !important'
          }}
        >
      {/* Header Section */}
      <Box sx={{ mb: 3 }}>
        {/* Enhanced Page Header */}
        <Card sx={{ 
          borderRadius: 3,
          mb: 3,
          mt: 5,
          border: `1px solid ${theme.palette.grey[400]}`,
          background: theme.palette.grey[100],
          backdropFilter: 'blur(20px)',
          borderTop: '3px solid #FF9800',
          boxShadow: 'none',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 2 }}>
              <Box sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: alpha('#FF9800', 0.08),
              }}>
                <MenuBookIcon sx={{ fontSize: 32, color: '#FF9800' }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography variant="h4" sx={{
                  fontWeight: 500,
                  color: '#FF9800',
                  mb: 1,
                  fontSize: '2rem',
                  letterSpacing: '-0.5px'
                }}>
                  Product Catalog Management
                </Typography>
                <Typography variant="body1" sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500,
                  fontSize: '1rem'
                }}>
                  {companyName || 'Loading...'}
                </Typography>
              </Box>
          </Box>
            <Typography variant="body2" sx={{ 
              color: 'text.secondary', 
              maxWidth: 700, 
              lineHeight: 1.5,
              fontSize: '0.95rem',
              fontWeight: 500
            }}>
              Manage your skincare and beauty product portfolio.
            </Typography>
          </CardContent>
        </Card>
      </Box>
      
      {error && (
        <Alert severity="error" sx={{ 
          mb: 3, 
          border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`, 
          borderRadius: 3 
        }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      
      <Snackbar
        open={!!success}
        autoHideDuration={6000}
        onClose={() => setSuccess(null)}
        message={success}
      />
      
      {/* Top action bar */}
      <SectionPaper>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              size="small"
              value={filters.search}
              onChange={(e) => setFilters({...filters, search: e.target.value})}
              label="Search products..."
              sx={{ 
                minWidth: 280,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  bgcolor: 'white'
                }
              }}
            />
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Paper sx={{ 
              display: 'flex', 
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'grey.300',
              overflow: 'hidden'
            }}>
              <IconButton 
                onClick={() => setView('grid')} 
                color={view === 'grid' ? 'primary' : 'default'}
                sx={{ 
                  borderRadius: 0,
                  bgcolor: view === 'grid' ? 'primary.50' : 'transparent',
                  '&:hover': {
                    bgcolor: view === 'grid' ? 'primary.100' : 'grey.100'
                  }
                }}
              >
                <ViewModuleIcon />
              </IconButton>
              <IconButton 
                onClick={() => setView('list')} 
                color={view === 'list' ? 'primary' : 'default'}
                sx={{ 
                  borderRadius: 0,
                  bgcolor: view === 'list' ? 'primary.50' : 'transparent',
                  '&:hover': {
                    bgcolor: view === 'list' ? 'primary.100' : 'grey.100'
                  }
                }}
              >
                <ViewListIcon />
              </IconButton>
            </Paper>
            {canEdit && (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={handleAddNewProduct}
                sx={{
                borderRadius: 2,
                borderColor: 'grey.400',
                color: 'primary.main',
                borderWidth: 1,
                fontWeight: 500,
                px: 3,
                py: 1.5,
                background: 'white',
                border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                '&:hover': {
                  borderColor: 'grey.600',
                  backgroundColor: 'white',
                  transform: 'translateY(-1px)',
                  boxShadow: `0 4px 12px ${alpha(theme.palette.grey[400], 0.25)}`
                }
              }}
            >
              Add Product
            </Button>
            )}
          </Box>
        </Box>
      </SectionPaper>
      
      {/* Filter panel */}
      <SectionPaper>
        <SectionTitle variant="h6">
          <FilterListIcon />
          Filters
        </SectionTitle>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <Typography variant="caption" sx={{ 
                fontSize: '0.9rem',
                fontWeight: 500,
                color: 'text.secondary',
                mb: 1.5,
                ml: 1,
                display: 'block'
              }}>
                Brand
              </Typography>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setBrandFilterDialogOpen(true)}
                sx={{
                  height: 40,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  background: 'white',
                  justifyContent: 'flex-start',
                  px: 2,
                  py: 1,
                  color: selectedBrand !== 'all' ? 'text.primary' : 'text.secondary',
                  fontWeight: 500,
                  textTransform: 'none',
                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                  }
                }}
              >
                {selectedBrand !== 'all' ? 
                  brands.find(brand => brand.id === selectedBrand)?.name || 'All Brands' : 
                  'All Brands'
                }
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <Typography variant="caption" sx={{ 
                fontSize: '0.9rem',
                fontWeight: 500,
                color: 'text.secondary',
                mb: 1.5,
                ml: 1,
                display: 'block'
              }}>
                Category
              </Typography>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setCategoryFilterDialogOpen(true)}
                sx={{
                  height: 40,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  background: 'white',
                  justifyContent: 'flex-start',
                  px: 2,
                  py: 1,
                  color: selectedCategory !== 'all' ? 'text.primary' : 'text.secondary',
                  fontWeight: 500,
                  textTransform: 'none',
                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                  }
                }}
              >
                {selectedCategory !== 'all' ? 
                  categories.find(category => category.id === selectedCategory)?.name || 'All Categories' : 
                  'All Categories'
                }
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <Typography variant="caption" sx={{ 
                fontSize: '0.9rem',
                fontWeight: 500,
                color: 'text.secondary',
                mb: 1.5,
                ml: 1,
                display: 'block'
              }}>
                Skin Type
              </Typography>
              <FormControl fullWidth size="small">              
                <Select                
                  value={filters.skinType}                
                  onChange={(e) => setFilters({...filters, skinType: e.target.value})}                
                  displayEmpty
                  sx={{
                    height: 40,
                    borderRadius: 2,
                    bgcolor: 'white',
                    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none'
                    },
                    '&:hover': {
                      border: `1px solid ${theme.palette.primary.main}`,
                      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                    },
                    '&.Mui-focused': {
                      border: `1px solid ${theme.palette.primary.main}`,
                      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`
                    }
                  }}
                >                
                  {skinTypes.map(type => (                  
                    <MenuItem key={type} value={type === 'All Skin Types' ? 'all' : type}>{type}</MenuItem>                
                  ))}              
                </Select>            
              </FormControl>
            </Box>
          </Grid>          
          <Grid item xs={12} sm={6} md={3}>            
            <Box>
              <Typography variant="caption" sx={{ 
                fontSize: '0.9rem',
                fontWeight: 500,
                color: 'text.secondary',
                mb: 1.5,
                ml: 1,
                display: 'block'
              }}>
                Actions
              </Typography>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => {
                  setSelectedBrand('all');
                  setSelectedCategory('all');
                  setFilters({
                    search: '',
                    skinType: 'all',
                    inStock: false,
                    priceRange: [0, 1000],
                  });
                }}
                sx={{ 
                  height: 40, 
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  background: 'white',
                  color: 'text.primary',
                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                  }
                }}
              >
                Reset All
              </Button>
            </Box>
          </Grid>
        </Grid>
      </SectionPaper>
      
      {/* Product Form Dialog */}
      <Dialog 
        open={showForm} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          pb: 2, 
          pt: 3,
          px: 3,
          fontSize: '1.25rem', 
          fontWeight: 500,
          color: 'text.primary',
          borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.8)}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{
              p: 1.5,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
            }}>
              {editingProduct ? <EditIcon sx={{ color: 'primary.main' }} /> : <AddIcon sx={{ color: 'primary.main' }} />}
            </Box>
            <Box>
              <Typography variant="h6" component="span" sx={{ fontWeight: 500, fontSize: '1.1rem', color: 'text.primary' }}>
                {editingProduct ? 'Edit Product' : 'Add New Product'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 0.5 }}>
                {editingProduct ? `Editing: ${editingProduct.name}` : 'Create a new product in your catalog'}
              </Typography>
            </Box>
          </Box>
          <IconButton 
            onClick={handleCancelForm} 
            size="small"
            sx={{ 
              color: 'text.secondary',
              '&:hover': {
                bgcolor: alpha(theme.palette.grey[400], 0.1),
                color: 'text.primary'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ px: 3, pt: 3 }}>
            <Stepper activeStep={activeStep} orientation="vertical" connector={<QontoConnector />}>
              <Step>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ 
                  '& .MuiStepLabel-label': {
                    fontSize: '1.1rem',
                    fontWeight: activeStep === 0 ? 500 : 400,
                    color: activeStep === 0 ? 'primary.main' : 'text.secondary'
              }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InfoOutlinedIcon sx={{ fontSize: 20 }} />
                    Basic Information
                  </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 3 }}>
                    {renderBasicInfoStep()}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <Button
                        variant="contained"
                        onClick={() => setActiveStep(1)}
                        disabled={!isStepValid(0)}
                        startIcon={<NavigateNextIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          bgcolor: alpha(theme.palette.grey[100], 0.8),
                          color: 'text.primary',
                          border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.grey[200], 0.8),
                            transform: 'translateY(-1px)'
                          }
                        }}
                      >
                        Next: Product Variants
                      </Button>
                    </Box>
                  </Box>
                </StepContent>
              </Step>
              
              <Step>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ 
                  '& .MuiStepLabel-label': {
                    fontSize: '1.1rem',
                    fontWeight: activeStep === 1 ? 500 : 400,
                    color: activeStep === 1 ? 'primary.main' : 'text.secondary'
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InventoryIcon sx={{ fontSize: 20 }} />
                    Product Variants
                  </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 3 }}>
                    {renderVariantsStep()}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                      <Button
                        onClick={() => setActiveStep(0)}
                        startIcon={<NavigateBeforeIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5
                        }}
                      >
                        Back
                      </Button>
                    <Button 
                        variant="contained"
                        onClick={() => setActiveStep(2)}
                        disabled={!isStepValid(1)}
                        startIcon={<NavigateNextIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          bgcolor: alpha(theme.palette.grey[100], 0.8),
                          color: 'text.primary',
                          border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.grey[200], 0.8),
                            transform: 'translateY(-1px)'
                          }
                        }}
                    >
                        Next: Formulation Details
                    </Button>
                  </Box>
                  </Box>
                </StepContent>
              </Step>
              
              <Step>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ 
                  '& .MuiStepLabel-label': {
                    fontSize: '1.1rem',
                    fontWeight: activeStep === 2 ? 500 : 400,
                    color: activeStep === 2 ? 'primary.main' : 'text.secondary'
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ScienceIcon sx={{ fontSize: 20 }} />
                    Formulation Details
                  </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 3 }}>
                    {renderFormulationStep()}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                                     <Button
                        onClick={() => setActiveStep(1)}
                        startIcon={<NavigateBeforeIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => setActiveStep(3)}
                        disabled={!isStepValid(2)}
                        startIcon={<NavigateNextIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          bgcolor: alpha(theme.palette.grey[100], 0.8),
                          color: 'text.primary',
                          border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.grey[200], 0.8),
                            transform: 'translateY(-1px)'
                          }
                        }}
                  >
                        Next: Ingredients & Certifications
                  </Button>
                </Box>
                  </Box>
                </StepContent>
              </Step>
              
              <Step>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ 
                  '& .MuiStepLabel-label': {
                    fontSize: '1.1rem',
                    fontWeight: activeStep === 3 ? 500 : 400,
                    color: activeStep === 3 ? 'primary.main' : 'text.secondary'
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <VerifiedIcon sx={{ fontSize: 20 }} />
                    Ingredients & Certifications
                    </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 3 }}>
                    {renderIngredientsStep()}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                      <Button
                        onClick={() => setActiveStep(2)}
                        startIcon={<NavigateBeforeIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => setActiveStep(4)}
                        disabled={!isStepValid(3)}
                        startIcon={<NavigateNextIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          bgcolor: alpha(theme.palette.grey[100], 0.8),
                          color: 'text.primary',
                          border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.grey[200], 0.8),
                            transform: 'translateY(-1px)'
                          }
                        }}
                      >
                        Next: Application Instructions
                      </Button>
                    </Box>
                  </Box>
                </StepContent>
              </Step>
              
              <Step>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ 
                  '& .MuiStepLabel-label': {
                    fontSize: '1.1rem',
                    fontWeight: activeStep === 4 ? 500 : 400,
                    color: activeStep === 4 ? 'primary.main' : 'text.secondary'
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AssignmentIcon sx={{ fontSize: 20 }} />
                    Application Instructions
                  </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 3 }}>
                    {renderApplicationStep()}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-start' }}>
                      <Button
                        onClick={() => setActiveStep(3)}
                        startIcon={<NavigateBeforeIcon />}
                        sx={{ 
                          borderRadius: 3,
                          px: 3,
                          py: 1.5
                        }}
                      >
                        Back
                      </Button>
                    </Box>
                  </Box>
                </StepContent>
              </Step>
            </Stepper>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          p: 3, 
          borderTop: 2, 
          borderColor: 'divider',
          bgcolor: alpha(theme.palette.grey[100], 0.5)
        }}>
            <Button 
              onClick={handleCancelForm}
              startIcon={<CloseIcon />}
              sx={{ 
                borderRadius: 3,
                px: 3,
                py: 1.5
              }}
            >
              Cancel
            </Button>
            <Button 
              variant="contained" 
              onClick={handleSubmitProduct}
              disabled={loading || !isStepValid(0) || !isStepValid(1) || !isStepValid(2) || !isStepValid(3) || !isStepValid(4)}
              startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
              sx={{
                borderRadius: 3,
                px: 3,
                py: 1.5,
                bgcolor: alpha(theme.palette.grey[100], 0.8),
                color: 'text.primary',
                border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                '&:hover': {
                  bgcolor: alpha(theme.palette.grey[200], 0.8),
                  transform: 'translateY(-1px)'
                }
              }}
            >
             {loading ? 'Saving...' : (editingProduct ? 'Update Product' : 'Create Product')}
            </Button>
        </DialogActions>
      </Dialog>
      
      {/* Loading state */}
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>

          
          {/* Products Display */}
          {filteredProducts.length === 0 ? (
            <Paper sx={{ 
              p: 6, 
              textAlign: 'center',
              borderRadius: 3,
              border: '2px dashed',
              borderColor: 'grey.300',
              bgcolor: 'grey.50'
            }}>
              <Box sx={{ mb: 3 }}>
                <AddIcon sx={{ fontSize: 60, color: 'grey.400' }} />
              </Box>
              <Typography variant="h5" color="text.primary" sx={{ fontWeight: 500, mb: 1 }}>
                No products found
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 4 }}>
                Try changing your filters or add a new beauty product to get started
              </Typography>
              {canEdit && (
                <Button 
                  variant="outlined" 
                  startIcon={<AddIcon />}
                  onClick={handleAddNewProduct}
                sx={{
                  borderRadius: 2,
                  borderColor: 'grey.400',
                  color: 'primary.main',
                  borderWidth: 1,
                  fontWeight: 500,
                  px: 3,
                  py: 1.5,
                  background: 'white',
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  '&:hover': {
                    borderColor: 'grey.600',
                    backgroundColor: 'white',
                    transform: 'translateY(-1px)',
                    boxShadow: `0 4px 12px ${alpha(theme.palette.grey[400], 0.25)}`
                  }
                }}
                >
                  Add Your First Product
                </Button>
              )}
            </Paper>
          ) : view === 'grid' ? (
            <>
              {(() => {
                const { organized, groupedProducts } = getOrganizedProducts();
                
                if (organized) {
                  return (
                    <>
                      {groupedProducts.map((group, index) => {
                        const { page, rowsPerPage } = getBrandPagination(group.brand.id);
                        const paginatedProducts = getPaginatedProducts(group.products, group.brand.id);
                        
                        return (
                          <React.Fragment key={group.brand.id}>
                            <BrandNameHeader sx={{ mb: 4, mt: index > 0 ? 10 : 0 }}>
                              <BrandNameTitle sx={{ 
                                fontSize: '1.75rem', 
                                fontWeight: 500,
                                py: 2,
                                borderBottom: `3px solid ${theme.palette.primary.main}`,
                                color: 'primary.main'
                              }}>
                                {group.brand.name} ({group.products.length})
                              </BrandNameTitle>
                            </BrandNameHeader>
                            <Grid container spacing={3} sx={{ mb: 3 }}>
                              {paginatedProducts.map((p, prodIndex) => (
                                <Grid item xs={12} sm={6} md={4} lg={2.4} key={p.id}>
                                  <ModernCard 
                                    sx={{ 
                                      maxWidth: '100%', 
                                      height: '100%', 
                                      display: 'flex', 
                                      flexDirection: 'column',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => handleViewProduct(p)}
                                  >
                                    <CardContent sx={{ flexGrow: 1, pt: 3 }}>
                                      <Typography variant="subtitle1" component="div" fontWeight="medium" gutterBottom>
                                        {p.name}
                                      </Typography>
                                      {p.certifications?.length > 0 && (
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                          {p.certifications.slice(0, 3).join(', ')}
                                        </Typography>
                                      )}
                                      <Box sx={{ mt: 2 }}>
                                        <Typography variant="body2" color="text.secondary">
                                          Product Code: {p.product_code || '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          Brand: {p.brand?.name || '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          SKU: {p.sku || '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          Category: {p.category?.name || '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          Skin Type: {p.skin_type || 'All Skin Types'}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      </Box>
                                    </CardContent>
                                    <CardActions className="product-actions" sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
                                      <IconButton 
                                        size="small" 
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          if (canEdit) handleEditProduct(p);
                                        }}
                                        disabled={!canEdit}
                                        sx={{
                                          color: canEdit ? 'info.main' : 'text.disabled',
                                          '&:hover': canEdit ? {
                                            bgcolor: 'info.main',
                                            color: 'white'
                                          } : {},
                                          '&.Mui-disabled': {
                                            color: 'text.disabled'
                                          }
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      
                                      <IconButton 
                                        size="small" 
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          if (canEdit) handleDuplicateProduct(p);
                                        }}
                                        disabled={!canEdit}
                                        sx={{
                                          color: canEdit ? 'success.main' : 'text.disabled',
                                          '&:hover': canEdit ? {
                                            bgcolor: 'success.main',
                                            color: 'white'
                                          } : {},
                                          '&.Mui-disabled': {
                                            color: 'text.disabled'
                                          }
                                        }}
                                      >
                                        <ContentCopyIcon fontSize="small" />
                                      </IconButton>
                                      
                                      <IconButton 
                                        size="small" 
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          if (hasPermission('products.catalog.delete', 'delete')) setConfirmDelete(p);
                                        }}
                                        disabled={!hasPermission('products.catalog.delete', 'delete')}
                                        sx={{
                                          color: hasPermission('products.catalog.delete', 'delete') ? 'error.main' : 'text.disabled',
                                          '&:hover': hasPermission('products.catalog.delete', 'delete') ? {
                                            bgcolor: 'error.main',
                                            color: 'white'
                                          } : {},
                                          '&.Mui-disabled': {
                                            color: 'text.disabled'
                                          }
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </CardActions>
                                  </ModernCard>
                                </Grid>
                              ))}
                            </Grid>
                            
                            {/* Pagination Controls for Grid View */}
                            <Paper sx={{ 
                              mb: 6,
                              borderRadius: 3,
                              border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                              bgcolor: '#f8f9fa',
                              overflow: 'hidden',
                              display: 'flex',
                              justifyContent: 'center'
                            }}>
                              <TablePagination
                                component="div"
                                count={group.products.length}
                                page={page}
                                onPageChange={(event, newPage) => handleBrandPageChange(group.brand.id, newPage)}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={(event) => handleBrandRowsPerPageChange(group.brand.id, event)}
                                rowsPerPageOptions={[5, 10, 25]}
                                sx={{
                                  '& .MuiTablePagination-toolbar': {
                                    minHeight: 52,
                                    px: 2,
                                    justifyContent: 'center'
                                  },
                                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                    fontWeight: 500,
                                    color: 'text.secondary'
                                  },
                                  '& .MuiTablePagination-select': {
                                    borderRadius: 1,
                                    fontWeight: 500
                                  },
                                  '& .MuiTablePagination-actions': {
                                    '& .MuiIconButton-root': {
                                      borderRadius: 1,
                                      transition: 'all 0.2s ease',
                                      '&:hover': {
                                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                                        transform: 'scale(1.05)'
                                      }
                                    }
                                  }
                                }}
                              />
                            </Paper>
                          </React.Fragment>
                        );
                      })}
                    </> 
                  );
                }
              })()}
            </>
          ) : (
            <>
              {(() => {
                const { organized, groupedProducts } = getOrganizedProducts();
                
                if (organized) {
                  // Group products by brand for table display
                  const productsByBrand = {};
                  groupedProducts.forEach(group => {
                    productsByBrand[group.brand.id] = group;
                  });
                  
                  return (
                    <>
                      {Object.keys(productsByBrand).map((brandId, brandIndex) => {
                        const brandGroup = productsByBrand[brandId];
                        const { page, rowsPerPage } = getBrandPagination(brandId);
                        const paginatedProducts = getPaginatedProducts(brandGroup.products, brandId);
                        
                        return (
                          <ProductTableContainer 
                            key={brandId}
                            sx={{ 
                              borderRadius: 3, 
                              border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                              background: `linear-gradient(135deg, ${alpha(theme.palette.grey[100], 0.8)}, ${alpha(theme.palette.grey[50], 0.9)})`,
                              boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.15)}`,
                              overflow: 'hidden',
                              mb: 6,
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              animation: 'slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              '@keyframes slideInUp': {
                                '0%': {
                                  transform: 'translateY(100%)',
                                  opacity: 0,
                                },
                                '100%': {
                                  transform: 'translateY(0)',
                                  opacity: 1,
                                }
                              },
                              '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.25)}`,
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
                              }
                            }}
                          >
                            {/* Brand Header */}
                            <Box sx={{ 
                              bgcolor: alpha(theme.palette.primary.main, 0.08),
                              borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                              py: 2,
                              px: 3
                            }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography 
                                  variant="h6" 
                                  sx={{ 
                                    fontWeight: 500,
                                    color: 'primary.main',
                                    fontSize: '1.1rem'
                                  }}
                                >
                                  {brandGroup.brand.name}
                                </Typography>
                                <Chip 
                                  label={`${brandGroup.products.length} products`}
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  sx={{ ml: 1 }}
                                />
                              </Box>
                            </Box>
                            
                            <TableContainer sx={{ overflow: 'visible' }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell 
                                      sx={{ 
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3
                                      }}
                                    >
                                      Product
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3
                                      }}
                                    >
                                      Product Code
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3
                                      }}
                                    >
                                      SKU
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3
                                      }}
                                    >
                                      Category
                                    </TableCell>
                                    <TableCell 
                                      sx={{ 
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3
                                      }}
                                    >
                                      Skin Type
                                    </TableCell>
                                    <TableCell 
                                      align="center"
                                      sx={{ 
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        bgcolor: 'white',
                                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                                        color: 'primary.main',
                                        py: 2,
                                        px: 3,
                                        width: 180
                                      }}
                                    >
                                      Actions
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {paginatedProducts.map((p) => (
                                    <TableRow 
                                      key={p.id}
                                      hover
                                      onClick={() => handleViewProduct(p)}
                                      sx={{ 
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                          bgcolor: 'grey.50',
                                          transform: 'translateX(4px)',
                                          transition: 'all 0.2s ease',
                                          boxShadow: 'inset 4px 0 0 black'
                                        },
                                        '& .MuiTableCell-root': {
                                          borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.6)}`,
                                          py: 2.5,
                                          px: 3
                                        }
                                      }}
                                    >
                                      <TableCell>
                                        <Box>
                                          <Typography 
                                            variant="body1" 
                                            sx={{ 
                                              fontWeight: 500,
                                              color: 'text.primary',
                                              fontSize: '0.95rem'
                                            }}
                                          >
                                            {p.name}
                                          </Typography>
                                          {p.certifications?.length > 0 && (
                                            <Typography 
                                              variant="caption" 
                                              color="text.secondary" 
                                              sx={{ 
                                                mt: 0.5, 
                                                display: 'block',
                                                fontSize: '0.8rem',
                                                fontWeight: 500
                                              }}
                                            >
                                              {p.certifications.slice(0, 3).join(', ')}
                                            </Typography>
                                          )}
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 500,
                                            color: 'primary.main',
                                            fontSize: '0.9rem'
                                          }}
                                        >
                                          {p.product_code || '-'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            fontSize: '0.9rem'
                                          }}
                                        >
                                          {p.sku || '-'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            fontSize: '0.9rem'
                                          }}
                                        >
                                          {p.category?.name || '-'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography 
                                          variant="body2" 
                                          sx={{ 
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            fontSize: '0.9rem'
                                          }}
                                        >
                                          {p.skin_type || 'All Skin Types'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
                                          <IconButton 
                                            size="small" 
                                            onClick={(e) => { 
                                              e.stopPropagation(); 
                                              if (canEdit) handleEditProduct(p); 
                                            }}
                                            disabled={!canEdit}
                                            sx={{
                                              color: canEdit ? 'info.main' : 'text.disabled',
                                              border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                              borderRadius: 2,
                                              transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                              '&:hover': canEdit ? {
                                                bgcolor: 'info.main',
                                                color: 'white',
                                                transform: 'scale(1.05)',
                                                boxShadow: `0 4px 12px ${alpha(theme.palette.info.main, 0.3)}`
                                              } : {},
                                              '&.Mui-disabled': {
                                                color: 'text.disabled',
                                                border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                              }
                                            }}
                                          >
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                          
                                          <IconButton 
                                            size="small" 
                                            onClick={(e) => { 
                                              e.stopPropagation(); 
                                              if (canEdit) handleDuplicateProduct(p); 
                                            }}
                                            disabled={!canEdit}
                                            sx={{
                                              color: canEdit ? 'success.main' : 'text.disabled',
                                              border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                              borderRadius: 2,
                                              transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                              '&:hover': canEdit ? {
                                                bgcolor: 'success.main',
                                                color: 'white',
                                                transform: 'scale(1.05)',
                                                boxShadow: `0 4px 12px ${alpha(theme.palette.success.main, 0.3)}`
                                              } : {},
                                              '&.Mui-disabled': {
                                                color: 'text.disabled',
                                                border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                              }
                                            }}
                                          >
                                            <ContentCopyIcon fontSize="small" />
                                          </IconButton>
                                          
                                          <IconButton 
                                            size="small" 
                                            onClick={(e) => { 
                                              e.stopPropagation(); 
                                              if (hasPermission('products.catalog.delete', 'delete')) setConfirmDelete(p); 
                                            }}
                                            disabled={!hasPermission('products.catalog.delete', 'delete')}
                                            sx={{
                                              color: hasPermission('products.catalog.delete', 'delete') ? 'error.main' : 'text.disabled',
                                              border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                              borderRadius: 2,
                                              transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                              '&:hover': hasPermission('products.catalog.delete', 'delete') ? {
                                                bgcolor: 'error.main',
                                                color: 'white',
                                                transform: 'scale(1.05)',
                                                boxShadow: `0 4px 12px ${alpha(theme.palette.error.main, 0.3)}`
                                              } : {},
                                              '&.Mui-disabled': {
                                                color: 'text.disabled',
                                                border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                              }
                                            }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            
                            {/* Pagination Controls */}
                            <TablePagination
                              component="div"
                              count={brandGroup.products.length}
                              page={page}
                              onPageChange={(event, newPage) => handleBrandPageChange(brandId, newPage)}
                              rowsPerPage={rowsPerPage}
                              onRowsPerPageChange={(event) => handleBrandRowsPerPageChange(brandId, event)}
                              rowsPerPageOptions={[5, 10, 25]}
                              sx={{
                                bgcolor: 'white',
                                borderTop: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                px: 3,
                                py: 1,
                                '& .MuiTablePagination-toolbar': {
                                  minHeight: 52
                                },
                                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                  fontWeight: 500,
                                  color: 'text.secondary'
                                },
                                '& .MuiTablePagination-select': {
                                  borderRadius: 1,
                                  fontWeight: 500
                                },
                                '& .MuiTablePagination-actions': {
                                  '& .MuiIconButton-root': {
                                    borderRadius: 1,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      bgcolor: alpha(theme.palette.primary.main, 0.08),
                                      transform: 'scale(1.05)'
                                    }
                                  }
                                }
                              }}
                            />
                          </ProductTableContainer>
                        );
                      })}
                    </>
                  );
                } else {
                  return (
                    <ProductTableContainer>
                      <TableContainer sx={{ overflow: 'visible' }}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell 
                                sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                Product
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                Product Code
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                SKU
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                Brand
                              </TableCell>
                              <TableCell 
                                sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                Category
                              </TableCell>
                              <TableCell 
                                sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}
                              >
                                Skin Type
                              </TableCell>
                              <TableCell 
                                align="center"
                                sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3,
                                  width: 180
                                }}
                              >
                                Actions
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredProducts.map((p) => (
                              <TableRow 
                                key={p.id}
                                hover
                                onClick={() => handleViewProduct(p)}
                                sx={{ 
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  '&:hover': { 
                                    bgcolor: 'grey.50',
                                    transform: 'translateX(4px)',
                                    transition: 'all 0.2s ease',
                                    boxShadow: 'inset 4px 0 0 black'
                                  },
                                  '& .MuiTableCell-root': {
                                    borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.6)}`,
                                    py: 2.5,
                                    px: 3
                                  }
                                }}
                              >
                                <TableCell>
                                  <Box>
                                    <Typography 
                                      variant="body1" 
                                      sx={{ 
                                        fontWeight: 500,
                                        color: 'text.primary',
                                        fontSize: '0.95rem'
                                      }}
                                    >
                                      {p.name}
                                    </Typography>
                                    {p.certifications?.length > 0 && (
                                      <Typography 
                                        variant="caption" 
                                        color="text.secondary" 
                                        sx={{ 
                                          mt: 0.5, 
                                          display: 'block',
                                          fontSize: '0.8rem',
                                          fontWeight: 500
                                        }}
                                      >
                                        {p.certifications.slice(0, 3).join(', ')}
                                      </Typography>
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 500,
                                      color: 'primary.main',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    {p.product_code || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 500,
                                      color: 'text.primary',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    {p.sku || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 500,
                                      color: 'text.primary',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    {p.brand?.name || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontWeight: 500,
                                      color: 'text.primary',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    {p.category?.name || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontWeight: 500,
                                      color: 'text.primary',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    {p.skin_type || 'All Skin Types'}
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center', minWidth: 120 }}>
                                    <IconButton 
                                      size="small" 
                                      onClick={(e) => { 
                                        e.stopPropagation(); 
                                        if (canEdit) handleEditProduct(p); 
                                      }}
                                      disabled={!canEdit}
                                      sx={{
                                        color: canEdit ? 'info.main' : 'text.disabled',
                                        border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                        borderRadius: 2,
                                        transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                        '&:hover': canEdit ? {
                                          bgcolor: 'info.main',
                                          color: 'white',
                                          transform: 'scale(1.05)',
                                          boxShadow: `0 4px 12px ${alpha(theme.palette.info.main, 0.3)}`
                                        } : {},
                                        '&.Mui-disabled': {
                                          color: 'text.disabled',
                                          border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                        }
                                      }}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    
                                    <IconButton 
                                      size="small" 
                                      onClick={(e) => { 
                                        e.stopPropagation(); 
                                        if (canEdit) handleDuplicateProduct(p); 
                                      }}
                                      disabled={!canEdit}
                                      sx={{
                                        color: canEdit ? 'success.main' : 'text.disabled',
                                        border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                        borderRadius: 2,
                                        transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                        '&:hover': canEdit ? {
                                          bgcolor: 'success.main',
                                          color: 'white',
                                          transform: 'scale(1.05)',
                                          boxShadow: `0 4px 12px ${alpha(theme.palette.success.main, 0.3)}`
                                        } : {},
                                        '&.Mui-disabled': {
                                          color: 'text.disabled',
                                          border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                        }
                                      }}
                                    >
                                      <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                    
                                    <IconButton 
                                      size="small" 
                                      onClick={(e) => { 
                                        e.stopPropagation(); 
                                        if (hasPermission('products.catalog.delete', 'delete')) setConfirmDelete(p); 
                                      }}
                                      disabled={!hasPermission('products.catalog.delete', 'delete')}
                                      sx={{
                                        color: hasPermission('products.catalog.delete', 'delete') ? 'error.main' : 'text.disabled',
                                        border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                                        borderRadius: 2,
                                        transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                                        '&:hover': hasPermission('products.catalog.delete', 'delete') ? {
                                          bgcolor: 'error.main',
                                          color: 'white',
                                          transform: 'scale(1.05)',
                                          boxShadow: `0 4px 12px ${alpha(theme.palette.error.main, 0.3)}`
                                        } : {},
                                        '&.Mui-disabled': {
                                          color: 'text.disabled',
                                          border: `1px solid ${alpha(theme.palette.grey[300], 0.3)}`
                                        }
                                      }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </ProductTableContainer>
                  );
                }
              })()}
            </>
          )}
        </>
      )}
      
      {/* Delete Confirmation Dialog */}
      <Dialog 
        open={!!confirmDelete} 
        onClose={() => setConfirmDelete(null)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: 'none',
            background: `linear-gradient(135deg, ${alpha(theme.palette.grey[50], 0.9)}, ${alpha(theme.palette.grey[100], 0.9)})`,
            backdropFilter: 'blur(20px)',
            boxShadow: `0 24px 48px ${alpha(theme.palette.grey[900], 0.15)}`,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          p: 4, 
          borderBottom: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
          background: `linear-gradient(135deg, ${alpha(theme.palette.error.main, 0.08)}, ${alpha(theme.palette.error.main, 0.04)})`,
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}>
          <Box sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: alpha(theme.palette.error.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DeleteIcon sx={{ color: 'error.main', fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" sx={{ fontWeight: 500, fontSize: '1.1rem', color: 'text.primary' }}>
              Confirm Delete
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 0.5 }}>
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'text.primary', mt: 2 }}>
            Are you sure you want to delete <strong>{confirmDelete?.name}</strong>?
            This will permanently remove the product from your catalog.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ 
          borderTop: '1px solid', 
          borderColor: 'divider', 
          p: 2, 
          justifyContent: 'space-between' 
        }}>
          <Button 
            onClick={() => setConfirmDelete(null)}
            startIcon={<CloseIcon />}
            sx={{ 
              px: 3,
              borderRadius: 3,
              py: 1.5
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteProduct}
            sx={{
              px: 3,
              borderRadius: 3,
              py: 1.5,
              bgcolor: 'error.main',
              color: 'white',
              '&:hover': {
                bgcolor: 'error.dark',
                transform: 'translateY(-1px)'
              }
            }}
          >
            Delete Product
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Category Creation Dialog */}
      <Dialog 
        open={showCategoryForm} 
        onClose={() => setShowCategoryForm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add New Category</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              margin="normal"
              label="Category Name"
              name="name"
              value={newCategory.name}
              onChange={(e) => {
                const value = e.target.value;
                if (value.trim() === '' && value !== '') return;
                setNewCategory({...newCategory, name: value});
              }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Description"
              name="description"
              value={newCategory.description}
              onChange={(e) => {
                const value = e.target.value;
                if (value.trim() === '' && value !== '') return;
                setNewCategory({...newCategory, description: value});
              }}
              multiline
              rows={2}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCategoryForm(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmitCategory}>
            Save Category
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Product View Dialog */}
      <Dialog
        open={showViewDialog}
        onClose={() => setShowViewDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
            maxHeight: '90vh',
            boxShadow: '0 24px 48px rgba(0,0,0,0.15)',
            bgcolor: alpha(theme.palette.grey[50], 0.95),
            backdropFilter: 'blur(10px)',
            overflow: 'hidden'
          }
        }}
      >
        {viewingProduct && (
          <>
            <DialogTitle sx={{ 
              pb: 2, 
              pt: 3,
              px: 3,
              fontSize: '1.25rem', 
              fontWeight: 500,
              color: 'text.primary',
              borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.8)}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'white'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{
                  p: 1.5,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                }}>
                  <InfoOutlinedIcon sx={{ color: 'primary.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="span" sx={{ fontWeight: 500, fontSize: '1.1rem', color: 'text.primary' }}>
                    {viewingProduct.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 0.5 }}>
                    Product Details - {viewingProduct.brand?.name || 'No Brand'}
                  </Typography>
                </Box>
              </Box>
              <IconButton 
                onClick={() => setShowViewDialog(false)} 
                size="small"
                sx={{ 
                  color: 'text.secondary',
                  '&:hover': {
                    bgcolor: alpha(theme.palette.grey[400], 0.1),
                    color: 'text.primary'
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Box sx={{ borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.8)}` }}>
              <Tabs 
                value={viewTab} 
                onChange={(e, newValue) => setViewTab(newValue)}
                sx={{ 
                  bgcolor: 'white',
                  px: 2,
                  '& .MuiTab-root': {
                    fontWeight: 500,
                    textTransform: 'none',
                    fontSize: '1rem',
                    py: 2
                  }
                }}
                TabIndicatorProps={{
                  style: {
                    height: 3
                  }
                }}
              >
                <Tab label="Basic Info" icon={<InfoOutlinedIcon />} iconPosition="start" />
                <Tab label="Formulation" icon={<ScienceIcon />} iconPosition="start" />
                <Tab label="Ingredients & Certifications" icon={<FormatListBulletedIcon />} iconPosition="start" />
                <Tab label="Application Instructions" icon={<MenuBookIcon />} iconPosition="start" />
              </Tabs>
            </Box>
            <DialogContent sx={{ p: 0, bgcolor: alpha(theme.palette.grey[50], 0.95) }}>
              {/* Tab panel wrappers */}
              
              {/* Basic Info Tab */}
              <TabPanel value={viewTab} index={0}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Description
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.description || 'No description available'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Status
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Chip 
                          label={viewingProduct.is_active ? "Active" : "Inactive"} 
                          color={viewingProduct.is_active ? "success" : "default"} 
                          variant="filled"
                          size="medium"
                          sx={{ 
                            fontWeight: 500, 
                            px: 2, 
                            borderRadius: 2,
                            boxShadow: `0 2px 8px ${alpha(theme.palette.grey[900], 0.08)}`,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              transform: 'scale(1.05)',
                              boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.15)}`
                            }
                          }}
                        />
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          SKU
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="primary.main">
                        {viewingProduct.sku || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Category
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.category?.name || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Shelf Life
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.shelf_life_months ? `${viewingProduct.shelf_life_months} months` : 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Brand
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.brand?.name || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Product Code
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.product_code || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Product Type
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.product_type || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Packaging Used
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.packaging_used || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Label Version
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.label_version || '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Launch Date
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.launch_date ? (() => {
                          const [year, month, day] = viewingProduct.launch_date.split('-');
                          const date = new Date(year, month - 1, day);
                          return date.toLocaleDateString();
                        })() : '-'}
                      </Typography>
                    </Paper>
                  </Grid>
                  {/* Product Variants */}
                  {viewingProduct.variants && viewingProduct.variants.length > 0 && (
                    <Grid item xs={12}>
                      <Paper elevation={2} sx={{ 
                        borderRadius: 3, 
                        bgcolor: '#ffffff', 
                        boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                        border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                          border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                        }
                      }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', p: 3, borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.8)}` }}>
                          <Typography variant="h6" fontWeight={500} color="text.primary">
                            Product Variants
                          </Typography>
                          <Chip 
                            label={`${viewingProduct.variants.length} variant${viewingProduct.variants.length !== 1 ? 's' : ''}`}
                            size="small"
                            sx={{ 
                              ml: 2, 
                              bgcolor: 'primary.main', 
                              color: 'white',
                              fontWeight: 500,
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                transform: 'scale(1.1)',
                                boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.15)}`
                              }
                            }}
                          />
                        </Box>
                        <Box sx={{ p: 3 }}>
                          <TableContainer sx={{ 
                            overflow: 'auto',
                            border: `1px solid ${alpha(theme.palette.grey[300], 0.6)}`,
                            borderRadius: 2
                          }}>
                            <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Volume/Weight
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Unit
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Case Qty
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Barcode
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  SKU
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Case Price
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Unit Price
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Single Unit Cost
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Case Cost Price
                                </TableCell>
                                <TableCell sx={{ 
                                  fontWeight: 500,
                                  fontSize: '0.9rem',
                                  bgcolor: 'white',
                                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                                  color: 'primary.main',
                                  py: 2,
                                  px: 3
                                }}>
                                  Profit Margin
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {sortVariantsBySize(viewingProduct.variants).map((variant, index) => {
                                // Calculate profit margin if not available
                                let profitMargin = variant.attributes?.profit_margin || variant.profit_margin || '0';
                                if (profitMargin === '0' || !profitMargin) {
                                  const retailPrice = parseFloat(variant.price) || 0;
                                  const costPrice = parseFloat(variant.cost_price) || 0;
                                  if (retailPrice > 0) {
                                    profitMargin = calculateProfitMargin(retailPrice, costPrice);
                                  }
                                }
                                
                                return (
                                  <TableRow 
                                    key={index} 
                                    hover
                                    sx={{
                                      cursor: 'default',
                                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                      bgcolor: 'white',
                                      '&:hover': { 
                                        bgcolor: alpha(theme.palette.primary.main, 0.04),
                                        transform: 'translateY(-2px)',
                                        boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.12)}`,
                                        '& .MuiTableCell-root': {
                                          borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
                                        }
                                      },
                                      '&:nth-of-type(even)': {
                                        bgcolor: alpha(theme.palette.grey[50], 0.5)
                                      },
                                      '& .MuiTableCell-root': {
                                        borderBottom: `1px solid ${alpha(theme.palette.grey[300], 0.6)}`,
                                        py: 3,
                                        px: 3,
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                                      }
                                    }}
                                  >
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'text.primary',
                                        fontSize: '0.9rem'
                                      }}>
                                        {variant.volume_weight || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 400,
                                        color: 'text.secondary',
                                        fontSize: '0.9rem'
                                      }}>
                                        {variant.volume_unit || 'ml'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 400,
                                        color: 'text.secondary',
                                        fontSize: '0.9rem'
                                      }}>
                                        {variant.pack_quantity || '1'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 400,
                                        color: 'text.secondary',
                                        fontSize: '0.9rem'
                                      }}>
                                        {variant.barcode || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'primary.main',
                                        fontSize: '0.9rem'
                                      }}>
                                        {variant.sku || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'success.main',
                                        fontSize: '0.9rem'
                                      }}>
                                        ${parseFloat(variant.price || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'success.dark',
                                        fontSize: '0.9rem'
                                      }}>
                                        ${parseFloat(variant.unit_price || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'info.main',
                                        fontSize: '0.9rem'
                                      }}>
                                        ${parseFloat(variant.single_unit_cost || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body1" sx={{ 
                                        fontWeight: 500,
                                        color: 'warning.main',
                                        fontSize: '0.9rem'
                                      }}>
                                        ${parseFloat(variant.cost_price || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Chip 
                                        label={`${profitMargin}%`}
                                        color={parseFloat(profitMargin) >= 30 ? 'success' : parseFloat(profitMargin) >= 15 ? 'warning' : 'error'}
                                        variant="filled"
                                        size="small"
                                        sx={{ 
                                          fontWeight: 500,
                                          border: `1px solid`,
                                          borderColor: parseFloat(profitMargin) >= 30 ? 'success.main' : parseFloat(profitMargin) >= 15 ? 'warning.main' : 'error.main'
                                        }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                                                      </Table>
                          </TableContainer>
                        </Box>
                        </Paper>
                    </Grid>
                  )}
                </Grid>
              </TabPanel>

              {/* Formulation Tab */}
              <TabPanel value={viewTab} index={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Benefits
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.benefits || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Active Ingredients
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.active_ingredients || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      height: '100%', 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          pH Level
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="primary.main">
                        {viewingProduct.ph_level || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      height: '100%', 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Contains Fragrance
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Chip 
                          label={viewingProduct.fragrance ? "Yes" : "No"} 
                          color={viewingProduct.fragrance ? "warning" : "success"} 
                          variant="filled"
                          size="medium"
                          sx={{ 
                            fontWeight: 500,
                            px: 2,
                            borderRadius: 2,
                            boxShadow: `0 2px 8px ${alpha(theme.palette.grey[900], 0.08)}`,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              transform: 'scale(1.05)',
                              boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.15)}`
                            }
                          }}
                        />
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Ingredients & Certifications Tab */}
              <TabPanel value={viewTab} index={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Full Ingredient List
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.ingredients || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      height: '100%', 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Skin Type
                        </Typography>
                      </Box>
                      <Typography variant="h5" fontWeight={500} color="text.primary">
                        {viewingProduct.skin_type || 'All Skin Types'}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      height: '100%', 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Certifications
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {viewingProduct.certifications && viewingProduct.certifications.length > 0 ? (
                          viewingProduct.certifications.map((cert, index) => (
                            <Chip 
                              key={index} 
                              label={cert} 
                              color="primary" 
                              variant="filled" 
                              size="medium"
                              sx={{ 
                                borderRadius: 2, 
                                fontWeight: 500,
                                boxShadow: `0 2px 8px ${alpha(theme.palette.grey[900], 0.08)}`,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  transform: 'scale(1.05)',
                                  boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.15)}`
                                }
                              }}
                            />
                          ))
                        ) : (
                          <Typography variant="body1">None</Typography>
                        )}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Allergens
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.allergens || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Application Instructions Tab */}
              <TabPanel value={viewTab} index={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ 
                      p: 3, 
                      borderRadius: 3, 
                      bgcolor: '#ffffff', 
                      boxShadow: `0 8px 24px ${alpha(theme.palette.grey[900], 0.08)}`, 
                      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 16px 48px ${alpha(theme.palette.grey[900], 0.12)}`,
                        border: `1px solid ${alpha(theme.palette.grey[400], 1)}`
                      }
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={500} color="text.primary" gutterBottom>
                          Application Instructions
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                        {viewingProduct.application_instructions || 'Not specified'}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid', borderColor: 'divider', p: 2, justifyContent: 'space-between' }}>
              <Button 
                onClick={() => setShowViewDialog(false)} 
                sx={{ px: 3 }}
              >
                Close
              </Button>
              {canEdit && (
                <Button 
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={() => {
                    setShowViewDialog(false);
                    handleEditProduct(viewingProduct);
                  }}
                  sx={{ 
                    px: 3,
                    borderRadius: 3,
                    bgcolor: alpha(theme.palette.grey[100], 0.8),
                    color: 'text.primary',
                    border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                    '&:hover': {
                      bgcolor: alpha(theme.palette.grey[200], 0.8),
                      transform: 'translateY(-1px)'
                    }
                  }}
                >
                  Edit Product
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Brand Filter Dialog */}
      <Dialog
        open={brandFilterDialogOpen}
        onClose={() => {
          setBrandFilterDialogOpen(false);
          setBrandFilterSearchTerm('');
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: 'none',
            background: `linear-gradient(135deg, ${alpha(theme.palette.grey[50], 0.9)}, ${alpha(theme.palette.grey[100], 0.9)})`,
            backdropFilter: 'blur(20px)',
            boxShadow: `0 24px 48px ${alpha(theme.palette.primary.main, 0.15)}`,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          p: 4, 
          borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.04)})`,
          color: theme.palette.text.primary,
          fontWeight: 500
        }}>
          Select Brand Filter
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ mb: 4, mt: 3 }}>
            <TextField
              fullWidth
              placeholder="Search brands..."
              value={brandFilterSearchTerm}
              onChange={(e) => setBrandFilterSearchTerm(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  '& fieldset': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                    borderWidth: 1
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main
                  }
                }
              }}
            />
          </Box>
          
          <Box sx={{ 
            maxHeight: 400, 
            overflowY: 'auto',
            border: `2px solid ${theme.palette.grey[400]}`,
            borderRadius: 2,
            background: 'white',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none'
          }}>
            {/* All Brands option */}
            <Box
              onClick={() => handleBrandFilterSelection('all')}
              sx={{
                p: 3,
                borderBottom: `1px solid ${alpha(theme.palette.grey[200], 0.8)}`,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                backgroundColor: selectedBrand === 'all' ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.04),
                  transform: 'translateX(4px)',
                  boxShadow: 'inset 4px 0 0 black'
                }
              }}
            >
              <Typography variant="subtitle1">
                All Brands
              </Typography>
            </Box>
            
            {getFilteredBrandsForFilter().map(brand => (
              <Box
                key={brand.id}
                onClick={() => handleBrandFilterSelection(brand.id)}
                sx={{
                  p: 3,
                  borderBottom: `1px solid ${alpha(theme.palette.grey[200], 0.8)}`,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  backgroundColor: selectedBrand === brand.id ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.04),
                    transform: 'translateX(4px)',
                    boxShadow: 'inset 4px 0 0 black'
                  },
                  '&:last-child': {
                    borderBottom: 'none'
                  }
                }}
              >
                <Typography variant="subtitle1">
                  {brand.name}
                </Typography>
              </Box>
            ))}
            
            {getFilteredBrandsForFilter().length === 0 && brandFilterSearchTerm && (
              <Box sx={{ p: 6, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  No brands found matching your search.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 4, 
          gap: 2, 
          borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.04)})`
        }}>
          <Button 
            onClick={() => {
              setBrandFilterDialogOpen(false);
              setBrandFilterSearchTerm('');
            }}
            sx={{ 
              borderRadius: 2,
              px: 3,
              py: 1.5,
              color: theme.palette.text.secondary,
              fontWeight: 500,
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.04)
              }
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Category Filter Dialog */}
      <Dialog
        open={categoryFilterDialogOpen}
        onClose={() => {
          setCategoryFilterDialogOpen(false);
          setCategoryFilterSearchTerm('');
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: 'none',
            background: `linear-gradient(135deg, ${alpha(theme.palette.grey[50], 0.9)}, ${alpha(theme.palette.grey[100], 0.9)})`,
            backdropFilter: 'blur(20px)',
            boxShadow: `0 24px 48px ${alpha(theme.palette.primary.main, 0.15)}`,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          p: 4, 
          borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.04)})`,
          color: theme.palette.text.primary,
          fontWeight: 500
        }}>
          Select Category Filter
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ mb: 4, mt: 3 }}>
            <TextField
              fullWidth
              placeholder="Search categories..."
              value={categoryFilterSearchTerm}
              onChange={(e) => setCategoryFilterSearchTerm(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  '& fieldset': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                    borderWidth: 1
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main
                  }
                }
              }}
            />
          </Box>
          
          <Box sx={{ 
            maxHeight: 400, 
            overflowY: 'auto',
            border: `2px solid ${theme.palette.grey[400]}`,
            borderRadius: 2,
            background: 'white',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none'
          }}>
            {/* All Categories option */}
            <Box
              onClick={() => handleCategoryFilterSelection('all')}
              sx={{
                p: 3,
                borderBottom: `1px solid ${alpha(theme.palette.grey[200], 0.8)}`,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                backgroundColor: selectedCategory === 'all' ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.04),
                  transform: 'translateX(4px)',
                  boxShadow: 'inset 4px 0 0 black'
                }
              }}
            >
              <Typography variant="subtitle1">
                All Categories
              </Typography>
            </Box>
            
            {getFilteredCategoriesForFilter().map(category => (
              <Box
                key={category.id}
                onClick={() => handleCategoryFilterSelection(category.id)}
                sx={{
                  p: 3,
                  borderBottom: `1px solid ${alpha(theme.palette.grey[200], 0.8)}`,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  backgroundColor: selectedCategory === category.id ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.04),
                    transform: 'translateX(4px)',
                    boxShadow: 'inset 4px 0 0 black'
                  },
                  '&:last-child': {
                    borderBottom: 'none'
                  }
                }}
              >
                <Typography variant="subtitle1">
                  {category.name}
                </Typography>
              </Box>
            ))}
            
            {getFilteredCategoriesForFilter().length === 0 && categoryFilterSearchTerm && (
              <Box sx={{ p: 6, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  No categories found matching your search.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 4, 
          gap: 2, 
          borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.04)})`
        }}>
          <Button 
            onClick={() => {
              setCategoryFilterDialogOpen(false);
              setCategoryFilterSearchTerm('');
            }}
            sx={{ 
              borderRadius: 2,
              px: 3,
              py: 1.5,
              color: theme.palette.text.secondary,
              fontWeight: 500,
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.04)
              }
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Brand Selection Dialog */}
      <Dialog
        open={brandDialogOpen}
        onClose={() => {
          setBrandDialogOpen(false);
          setBrandSearchTerm('');
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
            boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.2)}`
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 500,
          fontSize: '1.2rem',
          color: 'primary.main',
          borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          background: alpha(theme.palette.primary.main, 0.05)
        }}>
          Select Brand
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 3, borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.8)}` }}>
            <TextField
              fullWidth
              placeholder="Search brands..."
              value={brandSearchTerm}
              onChange={(e) => setBrandSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: 3,
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  background: 'white',
                  fontSize: '0.9rem',
                  '& fieldset': { border: 'none' },
                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                  },
                  '&.Mui-focused': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`
                  }
                }
              }}
            />
          </Box>
          <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
            {getFilteredBrands().length === 0 ? (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography color="text.secondary">
                  {brandSearchTerm ? 'No brands found matching your search.' : 'No brands available.'}
                </Typography>
              </Box>
            ) : (
              getFilteredBrands().map((brand) => (
                <Box
                  key={brand.id}
                  onClick={() => handleBrandSelection(brand.id)}
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05)
                    },
                    '&:last-child': {
                      borderBottom: 'none'
                    }
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {brand.name}
                  </Typography>
                </Box>
              ))
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 3, 
          borderTop: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => {
              setBrandDialogOpen(false);
              setBrandSearchTerm('');
              window.open(`/company/${companyId}/brands`, '_blank');
            }}
            sx={{
              borderRadius: 2,
              border: `1px solid ${theme.palette.primary.main}`,
              color: 'primary.main',
              fontWeight: 500,
              px: 3,
              py: 1
            }}
          >
            Add Brand
          </Button>
          <Button 
            onClick={() => {
              setBrandDialogOpen(false);
              setBrandSearchTerm('');
            }}
            sx={{
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
              fontWeight: 500,
              px: 3,
              py: 1
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Category Selection Dialog */}
      <Dialog
        open={categoryDialogOpen}
        onClose={() => {
          setCategoryDialogOpen(false);
          setCategorySearchTerm('');
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
            boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.2)}`
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 500,
          fontSize: '1.2rem',
          color: 'primary.main',
          borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          background: alpha(theme.palette.primary.main, 0.05)
        }}>
          Select Category
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 3, borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.8)}` }}>
            <TextField
              fullWidth
              placeholder="Search categories..."
              value={categorySearchTerm}
              onChange={(e) => setCategorySearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: 3,
                  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
                  background: 'white',
                  fontSize: '0.9rem',
                  '& fieldset': { border: 'none' },
                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
                  },
                  '&.Mui-focused': {
                    border: `1px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`
                  }
                }
              }}
            />
          </Box>
          <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
            {getFilteredCategories().length === 0 ? (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography color="text.secondary">
                  {categorySearchTerm ? 'No categories found matching your search.' : 'No categories available.'}
                </Typography>
              </Box>
            ) : (
              getFilteredCategories().map((category) => (
                <Box
                  key={category.id}
                  onClick={() => handleCategorySelection(category.id)}
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    borderBottom: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05)
                    },
                    '&:last-child': {
                      borderBottom: 'none'
                    }
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {category.name}
                  </Typography>
                </Box>
              ))
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 3, 
          borderTop: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => {
              setCategoryDialogOpen(false);
              setShowCategoryForm(true);
            }}
            sx={{
              borderRadius: 2,
              border: `1px solid ${theme.palette.primary.main}`,
              color: 'primary.main',
              fontWeight: 500,
              px: 3,
              py: 1
            }}
          >
            Add New Category
          </Button>
          <Button 
            onClick={() => {
              setCategoryDialogOpen(false);
              setCategorySearchTerm('');
            }}
            sx={{
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
              fontWeight: 500,
              px: 3,
              py: 1
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

        </Container>
      </Box>
    </Fade>
    </LocalizationProvider>
  );
}